// --- İl Verileri ---
export const iller = [
  { id: '01', name: 'Adana' },
  { id: '02', name: 'Adıyaman' },
  { id: '03', name: 'Afyonkarahisar' },
  { id: '04', name: 'Ağrı' },
  { id: '05', name: 'Amasya' },
  { id: '06', name: 'Ankara' },
  { id: '07', name: 'Antalya' },
  { id: '08', name: 'Artvin' },
  { id: '09', name: 'Aydın' },
  { id: '10', name: 'Balıkesir' },
  { id: '11', name: 'Bilecik' },
  { id: '12', name: 'Bingöl' },
  { id: '13', name: 'Bitlis' },
  { id: '14', name: 'Bolu' },
  { id: '15', name: 'Burdur' },
  { id: '16', name: 'Bursa' },
  { id: '17', name: 'Çanakkale' },
  { id: '18', name: 'Çankırı' },
  { id: '19', name: 'Çorum' },
  { id: '20', name: 'Denizli' },
  { id: '21', name: 'Diyarbakır' },
  { id: '22', name: 'Edirne' },
  { id: '23', name: 'Elazığ' },
  { id: '24', name: 'Erzincan' },
  { id: '25', name: 'Erzurum' },
  { id: '26', name: 'Eskişehir' },
  { id: '27', name: 'Gaziantep' },
  { id: '28', name: 'Giresun' },
  { id: '29', name: 'Gümüşhane' },
  { id: '30', name: 'Hakkari' },
  { id: '31', name: 'Hatay' },
  { id: '32', name: 'Isparta' },
  { id: '33', name: 'Mersin' },
  { id: '34', name: 'İstanbul' },
  { id: '35', name: 'İzmir' },
  { id: '36', name: 'Kars' },
  { id: '37', name: 'Kastamonu' },
  { id: '38', name: 'Kayseri' },
  { id: '39', name: 'Kırklareli' },
  { id: '40', name: 'Kırşehir' },
  { id: '41', name: 'Kocaeli' },
  { id: '42', name: 'Konya' },
  { id: '43', name: 'Kütahya' },
  { id: '44', name: 'Malatya' },
  { id: '45', name: 'Manisa' },
  { id: '46', name: 'Kahramanmaraş' },
  { id: '47', name: 'Mardin' },
  { id: '48', name: 'Muğla' },
  { id: '49', name: 'Muş' },
  { id: '50', name: 'Nevşehir' },
  { id: '51', name: 'Niğde' },
  { id: '52', name: 'Ordu' },
  { id: '53', name: 'Rize' },
  { id: '54', name: 'Sakarya' },
  { id: '55', name: 'Samsun' },
  { id: '56', name: 'Siirt' },
  { id: '57', name: 'Sinop' },
  { id: '58', name: 'Sivas' },
  { id: '59', name: 'Tekirdağ' },
  { id: '60', name: 'Tokat' },
  { id: '61', name: 'Trabzon' },
  { id: '62', name: 'Tunceli' },
  { id: '63', name: 'Şanlıurfa' },
  { id: '64', name: 'Uşak' },
  { id: '65', name: 'Van' },
  { id: '66', name: 'Yozgat' },
  { id: '67', name: 'Zonguldak' },
  { id: '68', name: 'Aksaray' },
  { id: '69', name: 'Bayburt' },
  { id: '70', name: 'Karaman' },
  { id: '71', name: 'Kırıkkale' },
  { id: '72', name: 'Batman' },
  { id: '73', name: 'Şırnak' },
  { id: '74', name: 'Bartın' },
  { id: '75', name: 'Ardahan' },
  { id: '76', name: 'Iğdır' },
  { id: '77', name: 'Yalova' },
  { id: '78', name: 'Karabük' },
  { id: '79', name: 'Kilis' },
  { id: '80', name: 'Osmaniye' },
  { id: '81', name: 'Düzce' },
];

// --- İlçe Verileri (İl ID'sine göre gruplandırılmış) ---
export const ilceler = {
  '01': [
    { id: '0101', name: 'Seyhan' },
    { id: '0102', name: 'Ceyhan' },
    { id: '0103', name: 'Feke' },
    { id: '0104', name: 'Karaisalı' },
    { id: '0105', name: 'Karataş' },
    { id: '0106', name: 'Kozan' },
    { id: '0107', name: 'Pozantı' },
    { id: '0108', name: 'Saimbeyli' },
    { id: '0109', name: 'Tufanbeyli' },
    { id: '0110', name: 'Yumurtalık' },
    { id: '0111', name: 'Yüreğir' },
    { id: '0112', name: 'Aladağ' },
    { id: '0113', name: 'İmamoğlu' },
    { id: '0114', name: 'Sarıçam' },
    { id: '0115', name: 'Çukurova' },
  ],
  '02': [
    { id: '0201', name: 'Adıyaman Merkez' },
    { id: '0202', name: 'Besni' },
    { id: '0203', name: 'Çelikhan' },
    { id: '0204', name: 'Gerger' },
    { id: '0205', name: 'Gölbaşı' },
    { id: '0206', name: 'Kahta' },
    { id: '0207', name: 'Samsat' },
    { id: '0208', name: 'Sincik' },
    { id: '0209', name: 'Tut' },
  ],
  '03': [
    { id: '0301', name: 'Afyonkarahisar Merkez' },
    { id: '0302', name: 'Bolvadin' },
    { id: '0303', name: 'Çay' },
    { id: '0304', name: 'Dazkırı' },
    { id: '0305', name: 'Dinar' },
    { id: '0306', name: 'Emirdağ' },
    { id: '0307', name: 'İhsaniye' },
    { id: '0308', name: 'Sandıklı' },
    { id: '0309', name: 'Sinanpaşa' },
    { id: '0310', name: 'Sultandağı' },
    { id: '0311', name: 'Şuhut' },
    { id: '0312', name: 'Başmakçı' },
    { id: '0313', name: 'Bayat' },
    { id: '0314', name: 'İscehisar' },
    { id: '0315', name: 'Çobanlar' },
    { id: '0316', name: 'Evciler' },
    { id: '0317', name: 'Hocalar' },
    { id: '0318', name: 'Kızılören' },
  ],
  '04': [
    { id: '0401', name: 'Ağrı Merkez' },
    { id: '0402', name: 'Diyadin' },
    { id: '0403', name: 'Doğubayazıt' },
    { id: '0404', name: 'Eleşkirt' },
    { id: '0405', name: 'Hamur' },
    { id: '0406', name: 'Patnos' },
    { id: '0407', name: 'Taşlıçay' },
    { id: '0408', name: 'Tutak' },
  ],
  '05': [
    { id: '0501', name: 'Amasya Merkez' },
    { id: '0502', name: 'Göynücek' },
    { id: '0503', name: 'Gümüşhacıköy' },
    { id: '0504', name: 'Merzifon' },
    { id: '0505', name: 'Suluova' },
    { id: '0506', name: 'Taşova' },
    { id: '0507', name: 'Hamamözü' },
  ],
  '06': [
    { id: '0601', name: 'Altındağ' },
    { id: '0602', name: 'Ayaş' },
    { id: '0603', name: 'Bala' },
    { id: '0604', name: 'Beypazarı' },
    { id: '0605', name: 'Çamlıdere' },
    { id: '0606', name: 'Çankaya' },
    { id: '0607', name: 'Çubuk' },
    { id: '0608', name: 'Elmadağ' },
    { id: '0609', name: 'Güdül' },
    { id: '0610', name: 'Haymana' },
    { id: '0611', name: 'Kalecik' },
    { id: '0612', name: 'Kızılcahamam' },
    { id: '0613', name: 'Nallıhan' },
    { id: '0614', name: 'Polatlı' },
    { id: '0615', name: 'Şereflikoçhisar' },
    { id: '0616', name: 'Yenimahalle' },
    { id: '0617', name: 'Gölbaşı' },
    { id: '0618', name: 'Keçiören' },
    { id: '0619', name: 'Mamak' },
    { id: '0620', name: 'Sincan' },
    { id: '0621', name: 'Kazan' },
    { id: '0622', name: 'Akyurt' },
    { id: '0623', name: 'Etimesgut' },
    { id: '0624', name: 'Evren' },
    { id: '0625', name: 'Pursaklar' },
  ],
  '07': [
    { id: '0701', name: 'Akseki' },
    { id: '0702', name: 'Alanya' },
    { id: '0703', name: 'Elmalı' },
    { id: '0704', name: 'Finike' },
    { id: '0705', name: 'Gazipaşa' },
    { id: '0706', name: 'Gündoğmuş' },
    { id: '0707', name: 'Kaş' },
    { id: '0708', name: 'Korkuteli' },
    { id: '0709', name: 'Kumluca' },
    { id: '0710', name: 'Manavgat' },
    { id: '0711', name: 'Serik' },
    { id: '0712', name: 'Demre' },
    { id: '0713', name: 'İbradı' },
    { id: '0714', name: 'Kemer' },
    { id: '0715', name: 'Aksu' },
    { id: '0716', name: 'Döşemealtı' },
    { id: '0717', name: 'Kepez' },
    { id: '0718', name: 'Konyaaltı' },
    { id: '0719', name: 'Muratpaşa' },
  ],
  '08': [
    { id: '0801', name: 'Artvin Merkez' },
    { id: '0802', name: 'Ardanuç' },
    { id: '0803', name: 'Arhavi' },
    { id: '0804', name: 'Borçka' },
    { id: '0805', name: 'Hopa' },
    { id: '0806', name: 'Şavşat' },
    { id: '0807', name: 'Yusufeli' },
    { id: '0808', name: 'Murgul' },
  ],
  '09': [
    { id: '0901', name: 'Bozdoğan' },
    { id: '0902', name: 'Çine' },
    { id: '0903', name: 'Germencik' },
    { id: '0904', name: 'Karacasu' },
    { id: '0905', name: 'Koçarlı' },
    { id: '0906', name: 'Kuşadası' },
    { id: '0907', name: 'Kuyucak' },
    { id: '0908', name: 'Nazilli' },
    { id: '0909', name: 'Söke' },
    { id: '0910', name: 'Sultanhisar' },
    { id: '0911', name: 'Yenipazar' },
    { id: '0912', name: 'Buharkent' },
    { id: '0913', name: 'İncirliova' },
    { id: '0914', name: 'Karpuzlu' },
    { id: '0915', name: 'Köşk' },
    { id: '0916', name: 'Didim' },
    { id: '0917', name: 'Efeler' },
  ],
  '10': [
    { id: '1001', name: 'Ayvalık' },
    { id: '1002', name: 'Balya' },
    { id: '1003', name: 'Bandırma' },
    { id: '1004', name: 'Bigadiç' },
    { id: '1005', name: 'Burhaniye' },
    { id: '1006', name: 'Dursunbey' },
    { id: '1007', name: 'Edremit' },
    { id: '1008', name: 'Erdek' },
    { id: '1009', name: 'Gönen' },
    { id: '1010', name: 'Havran' },
    { id: '1011', name: 'İvrindi' },
    { id: '1012', name: 'Kepsut' },
    { id: '1013', name: 'Manyas' },
    { id: '1014', name: 'Savaştepe' },
    { id: '1015', name: 'Sındırgı' },
    { id: '1016', name: 'Susurluk' },
    { id: '1017', name: 'Marmara' },
    { id: '1018', name: 'Gömeç' },
    { id: '1019', name: 'Karesi' },
    { id: '1020', name: 'Altıeylül' },
  ],
  '11': [
    { id: '1101', name: 'Bilecik Merkez' },
    { id: '1102', name: 'Bozüyük' },
    { id: '1103', name: 'Gölpazarı' },
    { id: '1104', name: 'Osmaneli' },
    { id: '1105', name: 'Pazaryeri' },
    { id: '1106', name: 'Söğüt' },
    { id: '1107', name: 'Yenipazar' },
    { id: '1108', name: 'İnhisar' },
  ],
  '12': [
    { id: '1201', name: 'Bingöl Merkez' },
    { id: '1202', name: 'Genç' },
    { id: '1203', name: 'Karlıova' },
    { id: '1204', name: 'Kiğı' },
    { id: '1205', name: 'Solhan' },
    { id: '1206', name: 'Adaklı' },
    { id: '1207', name: 'Yayladere' },
    { id: '1208', name: 'Yedisu' },
  ],
  '13': [
    { id: '1301', name: 'Bitlis Merkez' },
    { id: '1302', name: 'Adilcevaz' },
    { id: '1303', name: 'Ahlat' },
    { id: '1304', name: 'Hizan' },
    { id: '1305', name: 'Mutki' },
    { id: '1306', name: 'Tatvan' },
    { id: '1307', name: 'Güroymak' },
  ],
  '14': [
    { id: '1401', name: 'Bolu Merkez' },
    { id: '1402', name: 'Gerede' },
    { id: '1403', name: 'Göynük' },
    { id: '1404', name: 'Kıbrıscık' },
    { id: '1405', name: 'Mengen' },
    { id: '1406', name: 'Mudurnu' },
    { id: '1407', name: 'Seben' },
    { id: '1408', name: 'Dörtdivan' },
    { id: '1409', name: 'Yeniçağa' },
  ],
  '15': [
    { id: '1501', name: 'Burdur Merkez' },
    { id: '1502', name: 'Ağlasun' },
    { id: '1503', name: 'Bucak' },
    { id: '1504', name: 'Gölhisar' },
    { id: '1505', name: 'Tefenni' },
    { id: '1506', name: 'Yeşilova' },
    { id: '1507', name: 'Karamanlı' },
    { id: '1508', name: 'Kemer' },
    { id: '1509', name: 'Altınyayla' },
    { id: '1510', name: 'Çavdır' },
    { id: '1511', name: 'Çeltikçi' },
  ],
  '16': [
    { id: '1601', name: 'Gemlik' },
    { id: '1602', name: 'İnegöl' },
    { id: '1603', name: 'İznik' },
    { id: '1604', name: 'Karacabey' },
    { id: '1605', name: 'Keles' },
    { id: '1606', name: 'Mudanya' },
    { id: '1607', name: 'Mustafakemalpaşa' },
    { id: '1608', name: 'Orhaneli' },
    { id: '1609', name: 'Orhangazi' },
    { id: '1610', name: 'Yenişehir' },
    { id: '1611', name: 'Büyükorhan' },
    { id: '1612', name: 'Harmancık' },
    { id: '1613', name: 'Nilüfer' },
    { id: '1614', name: 'Osmangazi' },
    { id: '1615', name: 'Yıldırım' },
    { id: '1616', name: 'Gürsu' },
    { id: '1617', name: 'Kestel' },
  ],
  '17': [
    { id: '1701', name: 'Çanakkale Merkez' },
    { id: '1702', name: 'Ayvacık' },
    { id: '1703', name: 'Bayramiç' },
    { id: '1704', name: 'Biga' },
    { id: '1705', name: 'Bozcaada' },
    { id: '1706', name: 'Çan' },
    { id: '1707', name: 'Eceabat' },
    { id: '1708', name: 'Ezine' },
    { id: '1709', name: 'Gelibolu' },
    { id: '1710', name: 'Gökçeada' },
    { id: '1711', name: 'Lapseki' },
    { id: '1712', name: 'Yenice' },
  ],
  '18': [
    { id: '1801', name: 'Çankırı Merkez' },
    { id: '1802', name: 'Çerkeş' },
    { id: '1803', name: 'Eldivan' },
    { id: '1804', name: 'Ilgaz' },
    { id: '1805', name: 'Kurşunlu' },
    { id: '1806', name: 'Orta' },
    { id: '1807', name: 'Şabanözü' },
    { id: '1808', name: 'Yapraklı' },
    { id: '1809', name: 'Atkaracalar' },
    { id: '1810', name: 'Kızılırmak' },
    { id: '1811', name: 'Bayramören' },
    { id: '1812', name: 'Korgun' },
  ],
  '19': [
    { id: '1901', name: 'Çorum Merkez' },
    { id: '1902', name: 'Alaca' },
    { id: '1903', name: 'Bayat' },
    { id: '1904', name: 'İskilip' },
    { id: '1905', name: 'Kargı' },
    { id: '1906', name: 'Mecitözü' },
    { id: '1907', name: 'Ortaköy' },
    { id: '1908', name: 'Osmancık' },
    { id: '1909', name: 'Sungurlu' },
    { id: '1910', name: 'Boğazkale' },
    { id: '1911', name: 'Uğurludağ' },
    { id: '1912', name: 'Dodurga' },
    { id: '1913', name: 'Laçin' },
    { id: '1914', name: 'Oğuzlar' },
  ],
  '20': [
    { id: '2001', name: 'Acıpayam' },
    { id: '2002', name: 'Buldan' },
    { id: '2003', name: 'Çal' },
    { id: '2004', name: 'Çameli' },
    { id: '2005', name: 'Çardak' },
    { id: '2006', name: 'Çivril' },
    { id: '2007', name: 'Güney' },
    { id: '2008', name: 'Kale' },
    { id: '2009', name: 'Sarayköy' },
    { id: '2010', name: 'Tavas' },
    { id: '2011', name: 'Babadağ' },
    { id: '2012', name: 'Bekilli' },
    { id: '2013', name: 'Honaz' },
    { id: '2014', name: 'Serinhisar' },
    { id: '2015', name: 'Pamukkale' },
    { id: '2016', name: 'Baklan' },
    { id: '2017', name: 'Beyağaç' },
    { id: '2018', name: 'Bozkurt' },
    { id: '2019', name: 'Merkezefendi' },
  ],
  '21': [
    { id: '2101', name: 'Bismil' },
    { id: '2102', name: 'Çermik' },
    { id: '2103', name: 'Çınar' },
    { id: '2104', name: 'Çüngüş' },
    { id: '2105', name: 'Dicle' },
    { id: '2106', name: 'Ergani' },
    { id: '2107', name: 'Hani' },
    { id: '2108', name: 'Hazro' },
    { id: '2109', name: 'Kulp' },
    { id: '2110', name: 'Lice' },
    { id: '2111', name: 'Silvan' },
    { id: '2112', name: 'Eğil' },
    { id: '2113', name: 'Kocaköy' },
    { id: '2114', name: 'Bağlar' },
    { id: '2115', name: 'Kayapınar' },
    { id: '2116', name: 'Sur' },
    { id: '2117', name: 'Yenişehir' },
  ],
  '22': [
    { id: '2201', name: 'Edirne Merkez' },
    { id: '2202', name: 'Enez' },
    { id: '2203', name: 'Havsa' },
    { id: '2204', name: 'İpsala' },
    { id: '2205', name: 'Keşan' },
    { id: '2206', name: 'Lalapaşa' },
    { id: '2207', name: 'Meriç' },
    { id: '2208', name: 'Uzunköprü' },
    { id: '2209', name: 'Süloğlu' },
  ],
  '23': [
    { id: '2301', name: 'Elazığ Merkez' },
    { id: '2302', name: 'Ağın' },
    { id: '2303', name: 'Baskil' },
    { id: '2304', name: 'Karakoçan' },
    { id: '2305', name: 'Keban' },
    { id: '2306', name: 'Maden' },
    { id: '2307', name: 'Palu' },
    { id: '2308', name: 'Sivrice' },
    { id: '2309', name: 'Arıcak' },
    { id: '2310', name: 'Kovancılar' },
    { id: '2311', name: 'Alacakaya' },
  ],
  '24': [
    { id: '2401', name: 'Erzincan Merkez' },
    { id: '2402', name: 'Çayırlı' },
    { id: '2403', name: 'İliç' },
    { id: '2404', name: 'Kemah' },
    { id: '2405', name: 'Kemaliye' },
    { id: '2406', name: 'Refahiye' },
    { id: '2407', name: 'Tercan' },
    { id: '2408', name: 'Üzümlü' },
    { id: '2409', name: 'Otlukbeli' },
  ],
  '25': [
    { id: '2501', name: 'Aşkale' },
    { id: '2502', name: 'Çat' },
    { id: '2503', name: 'Hınıs' },
    { id: '2504', name: 'Horasan' },
    { id: '2505', name: 'İspir' },
    { id: '2506', name: 'Karayazı' },
    { id: '2507', name: 'Narman' },
    { id: '2508', name: 'Oltu' },
    { id: '2509', name: 'Olur' },
    { id: '2510', name: 'Pasinler' },
    { id: '2511', name: 'Şenkaya' },
    { id: '2512', name: 'Tekman' },
    { id: '2513', name: 'Tortum' },
    { id: '2514', name: 'Karaçoban' },
    { id: '2515', name: 'Uzundere' },
    { id: '2516', name: 'Palandöken' },
    { id: '2517', name: 'Aziziye' },
    { id: '2518', name: 'Köprüköy' },
    { id: '2519', name: 'Yakutiye' },
  ],
  '26': [
    { id: '2601', name: 'Çifteler' },
    { id: '2602', name: 'Mahmudiye' },
    { id: '2603', name: 'Mihalıççık' },
    { id: '2604', name: 'Sarıcakaya' },
    { id: '2605', name: 'Seyitgazi' },
    { id: '2606', name: 'Sivrihisar' },
    { id: '2607', name: 'Alpu' },
    { id: '2608', name: 'Beylikova' },
    { id: '2609', name: 'İnönü' },
    { id: '2610', name: 'Günyüzü' },
    { id: '2611', name: 'Han' },
    { id: '2612', name: 'Mihalgazi' },
    { id: '2613', name: 'Odunpazarı' },
    { id: '2614', name: 'Tepebaşı' },
  ],
  '27': [
    { id: '2701', name: 'Araban' },
    { id: '2702', name: 'İslahiye' },
    { id: '2703', name: 'Nizip' },
    { id: '2704', name: 'Oğuzeli' },
    { id: '2705', name: 'Yavuzeli' },
    { id: '2706', name: 'Şahinbey' },
    { id: '2707', name: 'Şehitkamil' },
    { id: '2708', name: 'Karkamış' },
    { id: '2709', name: 'Nurdağı' },
  ],
  '28': [
    { id: '2801', name: 'Giresun Merkez' },
    { id: '2802', name: 'Alucra' },
    { id: '2803', name: 'Bulancak' },
    { id: '2804', name: 'Dereli' },
    { id: '2805', name: 'Espiye' },
    { id: '2806', name: 'Eynesil' },
    { id: '2807', name: 'Görele' },
    { id: '2808', name: 'Keşap' },
    { id: '2809', name: 'Şebinkarahisar' },
    { id: '2810', name: 'Tirebolu' },
    { id: '2811', name: 'Piraziz' },
    { id: '2812', name: 'Yağlıdere' },
    { id: '2813', name: 'Çamoluk' },
    { id: '2814', name: 'Çanakçı' },
    { id: '2815', name: 'Doğankent' },
    { id: '2816', name: 'Güce' },
  ],
  '29': [
    { id: '2901', name: 'Gümüşhane Merkez' },
    { id: '2902', name: 'Kelkit' },
    { id: '2903', name: 'Şiran' },
    { id: '2904', name: 'Torul' },
    { id: '2905', name: 'Köse' },
    { id: '2906', name: 'Kürtün' },
  ],
  '30': [
    { id: '3001', name: 'Hakkari Merkez' },
    { id: '3002', name: 'Çukurca' },
    { id: '3003', name: 'Şemdinli' },
    { id: '3004', name: 'Yüksekova' },
  ],
  '31': [
    { id: '3101', name: 'Altınözü' },
    { id: '3102', name: 'Dörtyol' },
    { id: '3103', name: 'Hassa' },
    { id: '3104', name: 'İskenderun' },
    { id: '3105', name: 'Kırıkhan' },
    { id: '3106', name: 'Reyhanlı' },
    { id: '3107', name: 'Samandağ' },
    { id: '3108', name: 'Yayladağı' },
    { id: '3109', name: 'Erzin' },
    { id: '3110', name: 'Belen' },
    { id: '3111', name: 'Kumlu' },
    { id: '3112', name: 'Antakya' },
    { id: '3113', name: 'Arsuz' },
    { id: '3114', name: 'Defne' },
    { id: '3115', name: 'Payas' },
  ],
  '32': [
    { id: '3201', name: 'Isparta Merkez' },
    { id: '3202', name: 'Atabey' },
    { id: '3203', name: 'Eğirdir' },
    { id: '3204', name: 'Gelendost' },
    { id: '3205', name: 'Keçiborlu' },
    { id: '3206', name: 'Senirkent' },
    { id: '3207', name: 'Sütçüler' },
    { id: '3208', name: 'Şarkikaraağaç' },
    { id: '3209', name: 'Uluborlu' },
    { id: '3210', name: 'Yalvaç' },
    { id: '3211', name: 'Aksu' },
    { id: '3212', name: 'Gönen' },
    { id: '3213', name: 'Yenişarbademli' },
  ],
  '33': [
    { id: '3301', name: 'Anamur' },
    { id: '3302', name: 'Erdemli' },
    { id: '3303', name: 'Gülnar' },
    { id: '3304', name: 'Mut' },
    { id: '3305', name: 'Silifke' },
    { id: '3306', name: 'Tarsus' },
    { id: '3307', name: 'Aydıncık' },
    { id: '3308', name: 'Bozyazı' },
    { id: '3309', name: 'Çamlıyayla' },
    { id: '3310', name: 'Akdeniz' },
    { id: '3311', name: 'Mezitli' },
    { id: '3312', name: 'Toroslar' },
    { id: '3313', name: 'Yenişehir' },
  ],
  '34': [
    { id: '3401', name: 'Adalar' },
    { id: '3402', name: 'Bakırköy' },
    { id: '3403', name: 'Beşiktaş' },
    { id: '3404', name: 'Beykoz' },
    { id: '3405', name: 'Beyoğlu' },
    { id: '3406', name: 'Çatalca' },
    { id: '3407', name: 'Fatih' },
    { id: '3408', name: 'Gaziosmanpaşa' },
    { id: '3409', name: 'Kadıköy' },
    { id: '3410', name: 'Kartal' },
    { id: '3411', name: 'Sarıyer' },
    { id: '3412', name: 'Silivri' },
    { id: '3413', name: 'Şile' },
    { id: '3414', name: 'Şişli' },
    { id: '3415', name: 'Üsküdar' },
    { id: '3416', name: 'Zeytinburnu' },
    { id: '3417', name: 'Büyükçekmece' },
    { id: '3418', name: 'Eminönü' },
    { id: '3419', name: 'Kağıthane' },
    { id: '3420', name: 'Küçükçekmece' },
    { id: '3421', name: 'Pendik' },
    { id: '3422', name: 'Ümraniye' },
    { id: '3423', name: 'Bayrampaşa' },
    { id: '3424', name: 'Avcılar' },
    { id: '3425', name: 'Bağcılar' },
    { id: '3426', name: 'Bahçelievler' },
    { id: '3427', name: 'Güngören' },
    { id: '3428', name: 'Maltepe' },
    { id: '3429', name: 'Sultanbeyli' },
    { id: '3430', name: 'Tuzla' },
    { id: '3431', name: 'Esenler' },
    { id: '3432', name: 'Arnavutköy' },
    { id: '3433', name: 'Ataşehir' },
    { id: '3434', name: 'Başakşehir' },
    { id: '3435', name: 'Beylikdüzü' },
    { id: '3436', name: 'Çekmeköy' },
    { id: '3437', name: 'Esenyurt' },
    { id: '3438', name: 'Sancaktepe' },
    { id: '3439', name: 'Sultangazi' },
    { id: '3440', name: 'Eyüpsultan' },
  ],
  '35': [
    { id: '3501', name: 'Aliağa' },
    { id: '3502', name: 'Bayındır' },
    { id: '3503', name: 'Bergama' },
    { id: '3504', name: 'Bornova' },
    { id: '3505', name: 'Çeşme' },
    { id: '3506', name: 'Dikili' },
    { id: '3507', name: 'Foça' },
    { id: '3508', name: 'Karaburun' },
    { id: '3509', name: 'Karşıyaka' },
    { id: '3510', name: 'Kemalpaşa' },
    { id: '3511', name: 'Kınık' },
    { id: '3512', name: 'Kiraz' },
    { id: '3513', name: 'Menemen' },
    { id: '3514', name: 'Ödemiş' },
    { id: '3515', name: 'Seferihisar' },
    { id: '3516', name: 'Selçuk' },
    { id: '3517', name: 'Tire' },
    { id: '3518', name: 'Torbalı' },
    { id: '3519', name: 'Urla' },
    { id: '3520', name: 'Beydağ' },
    { id: '3521', name: 'Buca' },
    { id: '3522', name: 'Konak' },
    { id: '3523', name: 'Menderes' },
    { id: '3524', name: 'Balçova' },
    { id: '3525', name: 'Çiğli' },
    { id: '3526', name: 'Gaziemir' },
    { id: '3527', name: 'Narlıdere' },
    { id: '3528', name: 'Güzelbahçe' },
    { id: '3529', name: 'Bayraklı' },
    { id: '3530', name: 'Karabağlar' },
  ],
  '36': [
    { id: '3601', name: 'Kars Merkez' },
    { id: '3602', name: 'Arpaçay' },
    { id: '3603', name: 'Digor' },
    { id: '3604', name: 'Kağızman' },
    { id: '3605', name: 'Sarıkamış' },
    { id: '3606', name: 'Selim' },
    { id: '3607', name: 'Susuz' },
    { id: '3608', name: 'Akyaka' },
  ],
  '37': [
    { id: '3701', name: 'Kastamonu Merkez' },
    { id: '3702', name: 'Abana' },
    { id: '3703', name: 'Araç' },
    { id: '3704', name: 'Azdavay' },
    { id: '3705', name: 'Bozkurt' },
    { id: '3706', name: 'Cide' },
    { id: '3707', name: 'Çatalzeytin' },
    { id: '3708', name: 'Daday' },
    { id: '3709', name: 'Devrekani' },
    { id: '3710', name: 'İnebolu' },
    { id: '3711', name: 'Küre' },
    { id: '3712', name: 'Taşköprü' },
    { id: '3713', name: 'Tosya' },
    { id: '3714', name: 'Ağlı' },
    { id: '3715', name: 'Doğanyurt' },
    { id: '3716', name: 'Hanönü' },
    { id: '3717', name: 'İhsangazi' },
    { id: '3718', name: 'Pınarbaşı' },
    { id: '3719', name: 'Seydiler' },
    { id: '3720', name: 'Şenpazar' },
  ],
  '38': [
    { id: '3801', name: 'Bünyan' },
    { id: '3802', name: 'Develi' },
    { id: '3803', name: 'Felahiye' },
    { id: '3804', name: 'İncesu' },
    { id: '3805', name: 'Pınarbaşı' },
    { id: '3806', name: 'Sarıoğlan' },
    { id: '3807', name: 'Sarız' },
    { id: '3808', name: 'Tomarza' },
    { id: '3809', name: 'Yahyalı' },
    { id: '3810', name: 'Yeşilhisar' },
    { id: '3811', name: 'Akkışla' },
    { id: '3812', name: 'Talas' },
    { id: '3813', name: 'Kocasinan' },
    { id: '3814', name: 'Melikgazi' },
    { id: '3815', name: 'Hacılar' },
    { id: '3816', name: 'Özvatan' },
  ],
  '39': [
    { id: '3901', name: 'Kırklareli Merkez' },
    { id: '3902', name: 'Babaeski' },
    { id: '3903', name: 'Demirköy' },
    { id: '3904', name: 'Kofçaz' },
    { id: '3905', name: 'Lüleburgaz' },
    { id: '3906', name: 'Pehlivanköy' },
    { id: '3907', name: 'Pınarhisar' },
    { id: '3908', name: 'Vize' },
  ],
  '40': [
    { id: '4001', name: 'Kırşehir Merkez' },
    { id: '4002', name: 'Çiçekdağı' },
    { id: '4003', name: 'Kaman' },
    { id: '4004', name: 'Mucur' },
    { id: '4005', name: 'Akpınar' },
    { id: '4006', name: 'Akçakent' },
    { id: '4007', name: 'Boztepe' },
  ],
  '41': [
    { id: '4101', name: 'Gebze' },
    { id: '4102', name: 'Gölcük' },
    { id: '4103', name: 'Kandıra' },
    { id: '4104', name: 'Karamürsel' },
    { id: '4105', name: 'Körfez' },
    { id: '4106', name: 'Derince' },
    { id: '4107', name: 'İzmit' },
    { id: '4108', name: 'Başiskele' },
    { id: '4109', name: 'Çayırova' },
    { id: '4110', name: 'Darıca' },
    { id: '4111', name: 'Dilovası' },
    { id: '4112', name: 'Kartepe' },
  ],
  '42': [
    { id: '4201', name: 'Akşehir' },
    { id: '4202', name: 'Beyşehir' },
    { id: '4203', name: 'Bozkır' },
    { id: '4204', name: 'Cihanbeyli' },
    { id: '4205', name: 'Çumra' },
    { id: '4206', name: 'Doğanhisar' },
    { id: '4207', name: 'Ereğli' },
    { id: '4208', name: 'Hadim' },
    { id: '4209', name: 'Ilgın' },
    { id: '4210', name: 'Kadınhanı' },
    { id: '4211', name: 'Karapınar' },
    { id: '4212', name: 'Kulu' },
    { id: '4213', name: 'Sarayönü' },
    { id: '4214', name: 'Seydişehir' },
    { id: '4215', name: 'Yunak' },
    { id: '4216', name: 'Akören' },
    { id: '4217', name: 'Altınekin' },
    { id: '4218', name: 'Derebucak' },
    { id: '4219', name: 'Hüyük' },
    { id: '4220', name: 'Karatay' },
    { id: '4221', name: 'Meram' },
    { id: '4222', name: 'Selçuklu' },
    { id: '4223', name: 'Taşkent' },
    { id: '4224', name: 'Ahırlı' },
    { id: '4225', name: 'Çeltik' },
    { id: '4226', name: 'Derbent' },
    { id: '4227', 'name': 'Emirgazi' },
    { id: '4228', 'name': 'Güneysınır' },
    { id: '4229', 'name': 'Halkapınar' },
    { id: '4230', 'name': 'Tuzlukçu' },
    { id: '4231', 'name': 'Yalıhüyük' },
  ],
  '43': [
    { id: '4301', name: 'Kütahya Merkez' },
    { id: '4302', name: 'Altıntaş' },
    { id: '4303', name: 'Domaniç' },
    { id: '4304', name: 'Emet' },
    { id: '4305', name: 'Gediz' },
    { id: '4306', name: 'Simav' },
    { id: '4307', name: 'Tavşanlı' },
    { id: '4308', name: 'Aslanapa' },
    { id: '4309', name: 'Dumlupınar' },
    { id: '4310', name: 'Hisarcık' },
    { id: '4311', name: 'Şaphane' },
    { id: '4312', name: 'Çavdarhisar' },
    { id: '4313', name: 'Pazarlar' },
  ],
  '44': [
    { id: '4401', name: 'Akçadağ' },
    { id: '4402', name: 'Arapgir' },
    { id: '4403', name: 'Arguvan' },
    { id: '4404', name: 'Darende' },
    { id: '4405', name: 'Doğanşehir' },
    { id: '4406', name: 'Hekimhan' },
    { id: '4407', name: 'Pütürge' },
    { id: '4408', name: 'Yeşilyurt' },
    { id: '4409', name: 'Battalgazi' },
    { id: '4410', name: 'Doğanyol' },
    { id: '4411', name: 'Kale' },
    { id: '4412', name: 'Kuluncak' },
    { id: '4413', name: 'Yazıhan' },
  ],
  '45': [
    { id: '4501', name: 'Akhisar' },
    { id: '4502', name: 'Alaşehir' },
    { id: '4503', name: 'Demirci' },
    { id: '4504', name: 'Gördes' },
    { id: '4505', name: 'Kırkağaç' },
    { id: '4506', name: 'Kula' },
    { id: '4507', name: 'Salihli' },
    { id: '4508', name: 'Sarıgöl' },
    { id: '4509', name: 'Saruhanlı' },
    { id: '4510', name: 'Selendi' },
    { id: '4511', name: 'Soma' },
    { id: '4512', name: 'Turgutlu' },
    { id: '4513', name: 'Ahmetli' },
    { id: '4514', name: 'Gölmarmara' },
    { id: '4515', name: 'Köprübaşı' },
    { id: '4516', name: 'Şehzadeler' },
    { id: '4517', name: 'Yunusemre' },
  ],
  '46': [
    { id: '4601', name: 'Afşin' },
    { id: '4602', name: 'Andırın' },
    { id: '4603', name: 'Elbistan' },
    { id: '4604', name: 'Göksun' },
    { id: '4605', name: 'Pazarcık' },
    { id: '4606', name: 'Türkoğlu' },
    { id: '4607', name: 'Çağlayancerit' },
    { id: '4608', name: 'Ekinözü' },
    { id: '4609', name: 'Nurhak' },
    { id: '4610', name: 'Dulkadiroğlu' },
    { id: '4611', name: 'Onikişubat' },
  ],
  '47': [
    { id: '4701', name: 'Derik' },
    { id: '4702', name: 'Kızıltepe' },
    { id: '4703', name: 'Mazıdağı' },
    { id: '4704', name: 'Midyat' },
    { id: '4705', name: 'Nusaybin' },
    { id: '4706', name: 'Ömerli' },
    { id: '4707', name: 'Savur' },
    { id: '4708', name: 'Dargeçit' },
    { id: '4709', name: 'Yeşilli' },
    { id: '4710', name: 'Artuklu' },
  ],
  '48': [
    { id: '4801', name: 'Bodrum' },
    { id: '4802', name: 'Datça' },
    { id: '4803', name: 'Fethiye' },
    { id: '4804', name: 'Köyceğiz' },
    { id: '4805', name: 'Marmaris' },
    { id: '4806', name: 'Milas' },
    { id: '4807', name: 'Ula' },
    { id: '4808', name: 'Yatağan' },
    { id: '4809', name: 'Dalaman' },
    { id: '4810', name: 'Ortaca' },
    { id: '4811', name: 'Kavaklıdere' },
    { id: '4812', name: 'Menteşe' },
    { id: '4813', name: 'Seydikemer' },
  ],
  '49': [
    { id: '4901', name: 'Muş Merkez' },
    { id: '4902', name: 'Bulanık' },
    { id: '4903', name: 'Malazgirt' },
    { id: '4904', name: 'Varto' },
    { id: '4905', name: 'Hasköy' },
    { id: '4906', name: 'Korkut' },
  ],
  '50': [
    { id: '5001', name: 'Nevşehir Merkez' },
    { id: '5002', name: 'Avanos' },
    { id: '5003', name: 'Derinkuyu' },
    { id: '5004', name: 'Gülşehir' },
    { id: '5005', name: 'Hacıbektaş' },
    { id: '5006', name: 'Kozaklı' },
    { id: '5007', name: 'Ürgüp' },
    { id: '5008', name: 'Acıgöl' },
  ],
  '51': [
    { id: '5101', name: 'Niğde Merkez' },
    { id: '5102', name: 'Bor' },
    { id: '5103', name: 'Çamardı' },
    { id: '5104', name: 'Ulukışla' },
    { id: '5105', name: 'Altunhisar' },
    { id: '5106', name: 'Çiftlik' },
  ],
  '52': [
    { id: '5201', name: 'Akkuş' },
    { id: '5202', name: 'Aybastı' },
    { id: '5203', name: 'Fatsa' },
    { id: '5204', name: 'Gölköy' },
    { id: '5205', name: 'Korgan' },
    { id: '5206', name: 'Kumru' },
    { id: '5207', name: 'Mesudiye' },
    { id: '5208', name: 'Perşembe' },
    { id: '5209', name: 'Ulubey' },
    { id: '5210', name: 'Ünye' },
    { id: '5211', name: 'Gülyalı' },
    { id: '5212', name: 'Gürgentepe' },
    { id: '5213', name: 'Çamaş' },
    { id: '5214', name: 'Çatalpınar' },
    { id: '5215', name: 'Çaybaşı' },
    { id: '5216', name: 'İkizce' },
    { id: '5217', name: 'Kabadüz' },
    { id: '5218', name: 'Kabataş' },
    { id: '5219', name: 'Altınordu' },
  ],
  '53': [
    { id: '5301', name: 'Rize Merkez' },
    { id: '5302', name: 'Ardeşen' },
    { id: '5303', name: 'Çamlıhemşin' },
    { id: '5304', name: 'Çayeli' },
    { id: '5305', 'name': 'Fındıklı' },
    { id: '5306', 'name': 'İkizdere' },
    { id: '5307', 'name': 'Kalkandere' },
    { id: '5308', 'name': 'Pazar' },
    { id: '5309', 'name': 'İyidere' },
    { id: '5310', 'name': 'Derepazarı' },
    { id: '5311', 'name': 'Güneysu' },
    { id: '5312', 'name': 'Hemşin' },
  ],
  '54': [
    { id: '5401', name: 'Akyazı' },
    { id: '5402', name: 'Geyve' },
    { id: '5403', name: 'Hendek' },
    { id: '5404', name: 'Karasu' },
    { id: '5405', name: 'Kaynarca' },
    { id: '5406', name: 'Sapanca' },
    { id: '5407', name: 'Kocaali' },
    { id: '5408', name: 'Pamukova' },
    { id: '5409', name: 'Taraklı' },
    { id: '5410', name: 'Ferizli' },
    { id: '5411', name: 'Karapürçek' },
    { id: '5412', name: 'Söğütlü' },
    { id: '5413', name: 'Adapazarı' },
    { id: '5414', name: 'Arifiye' },
    { id: '5415', name: 'Erenler' },
    { id: '5416', name: 'Serdivan' },
  ],
  '55': [
    { id: '5501', name: 'Alaçam' },
    { id: '5502', name: 'Bafra' },
    { id: '5503', name: 'Çarşamba' },
    { id: '5504', name: 'Havza' },
    { id: '5505', name: 'Kavak' },
    { id: '5506', name: 'Ladik' },
    { id: '5507', name: 'Terme' },
    { id: '5508', name: 'Vezirköprü' },
    { id: '5509', name: 'Asarcık' },
    { id: '5510', name: 'Ondokuzmayıs' },
    { id: '5511', name: 'Salıpazarı' },
    { id: '5512', name: 'Tekkeköy' },
    { id: '5513', name: 'Ayvacık' },
    { id: '5514', name: 'Yakakent' },
    { id: '5515', name: 'Atakum' },
    { id: '5516', name: 'Canik' },
    { id: '5517', name: 'İlkadım' },
  ],
  '56': [
    { id: '5601', name: 'Siirt Merkez' },
    { id: '5602', name: 'Baykan' },
    { id: '5603', name: 'Eruh' },
    { id: '5604', name: 'Kurtalan' },
    { id: '5605', name: 'Pervari' },
    { id: '5606', name: 'Şirvan' },
    { id: '5607', name: 'Tillo' },
  ],
  '57': [
    { id: '5701', name: 'Sinop Merkez' },
    { id: '5702', name: 'Ayancık' },
    { id: '5703', name: 'Boyabat' },
    { id: '5704', name: 'Durağan' },
    { id: '5705', name: 'Erfelek' },
    { id: '5706', name: 'Gerze' },
    { id: '5707', name: 'Türkeli' },
    { id: '5708', name: 'Dikmen' },
    { id: '5709', name: 'Saraydüzü' },
  ],
  '58': [
    { id: '5801', name: 'Sivas Merkez' },
    { id: '5802', name: 'Divriği' },
    { id: '5803', name: 'Gemerek' },
    { id: '5804', name: 'Gürün' },
    { id: '5805', name: 'Hafik' },
    { id: '5806', name: 'İmranlı' },
    { id: '5807', name: 'Kangal' },
    { id: '5808', name: 'Koyulhisar' },
    { id: '5809', name: 'Suşehri' },
    { id: '5810', name: 'Şarkışla' },
    { id: '5811', name: 'Yıldızeli' },
    { id: '5812', name: 'Zara' },
    { id: '5813', name: 'Akıncılar' },
    { id: '5814', name: 'Altınyayla' },
    { id: '5815', name: 'Doğanşar' },
    { id: '5816', name: 'Gölova' },
    { id: '5817', name: 'Ulaş' },
  ],
  '59': [
    { id: '5901', name: 'Çerkezköy' },
    { id: '5902', name: 'Çorlu' },
    { id: '5903', name: 'Hayrabolu' },
    { id: '5904', name: 'Malkara' },
    { id: '5905', name: 'Muratlı' },
    { id: '5906', name: 'Saray' },
    { id: '5907', name: 'Şarköy' },
    { id: '5908', name: 'Marmaraereğlisi' },
    { id: '5909', name: 'Ergene' },
    { id: '5910', name: 'Kapaklı' },
    { id: '5911', name: 'Süleymanpaşa' },
  ],
  '60': [
    { id: '6001', name: 'Tokat Merkez' },
    { id: '6002', name: 'Almus' },
    { id: '6003', name: 'Artova' },
    { id: '6004', name: 'Erbaa' },
    { id: '6005', name: 'Niksar' },
    { id: '6006', name: 'Reşadiye' },
    { id: '6007', name: 'Turhal' },
    { id: '6008', name: 'Zile' },
    { id: '6009', name: 'Pazar' },
    { id: '6010', name: 'Yeşilyurt' },
    { id: '6011', name: 'Başçiftlik' },
    { id: '6012', name: 'Sulusaray' },
  ],
  '61': [
    { id: '6101', name: 'Akçaabat' },
    { id: '6102', name: 'Araklı' },
    { id: '6103', name: 'Arsin' },
    { id: '6104', name: 'Çaykara' },
    { id: '6105', name: 'Maçka' },
    { id: '6106', name: 'Of' },
    { id: '6107', name: 'Sürmene' },
    { id: '6108', name: 'Tonya' },
    { id: '6109', name: 'Vakfıkebir' },
    { id: '6110', name: 'Yomra' },
    { id: '6111', name: 'Beşikdüzü' },
    { id: '6112', name: 'Şalpazarı' },
    { id: '6113', name: 'Çarşıbaşı' },
    { id: '6114', name: 'Dernekpazarı' },
    { id: '6115', name: 'Düzköy' },
    { id: '6116', name: 'Hayrat' },
    { id: '6117', name: 'Köprübaşı' },
    { id: '6118', name: 'Ortahisar' },
  ],
  '62': [
    { id: '6201', name: 'Tunceli Merkez' },
    { id: '6202', name: 'Çemişgezek' },
    { id: '6203', name: 'Hozat' },
    { id: '6204', name: 'Mazgirt' },
    { id: '6205', name: 'Nazımiye' },
    { id: '6206', name: 'Ovacık' },
    { id: '6207', name: 'Pertek' },
    { id: '6208', name: 'Pülümür' },
  ],
  '63': [
    { id: '6301', name: 'Akçakale' },
    { id: '6302', name: 'Birecik' },
    { id: '6303', name: 'Bozova' },
    { id: '6304', name: 'Ceylanpınar' },
    { id: '6305', name: 'Halfeti' },
    { id: '6306', name: 'Hilvan' },
    { id: '6307', name: 'Siverek' },
    { id: '6308', name: 'Suruç' },
    { id: '6309', name: 'Viranşehir' },
    { id: '6310', name: 'Harran' },
    { id: '6311', name: 'Eyyübiye' },
    { id: '6312', name: 'Haliliye' },
    { id: '6313', name: 'Karaköprü' },
  ],
  '64': [
    { id: '6401', name: 'Uşak Merkez' },
    { id: '6402', name: 'Banaz' },
    { id: '6403', name: 'Eşme' },
    { id: '6404', name: 'Karahallı' },
    { id: '6405', name: 'Sivaslı' },
    { id: '6406', name: 'Ulubey' },
  ],
  '65': [
    { id: '6501', name: 'Başkale' },
    { id: '6502', name: 'Çatak' },
    { id: '6503', name: 'Erciş' },
    { id: '6504', name: 'Gevaş' },
    { id: '6505', name: 'Gürpınar' },
    { id: '6506', name: 'Muradiye' },
    { id: '6507', name: 'Özalp' },
    { id: '6508', name: 'Bahçesaray' },
    { id: '6509', name: 'Çaldıran' },
    { id: '6510', name: 'Edremit' },
    { id: '6511', name: 'Saray' },
    { id: '6512', name: 'İpekyolu' },
    { id: '6513', name: 'Tuşba' },
  ],
  '66': [
    { id: '6601', name: 'Yozgat Merkez' },
    { id: '6602', name: 'Akdağmadeni' },
    { id: '6603', name: 'Boğazlıyan' },
    { id: '6604', name: 'Çayıralan' },
    { id: '6605', name: 'Çekerek' },
    { id: '6606', name: 'Sarıkaya' },
    { id: '6607', name: 'Sorgun' },
    { id: '6608', name: 'Şefaatli' },
    { id: '6609', name: 'Yerköy' },
    { id: '6610', name: 'Aydıncık' },
    { id: '6611', name: 'Çandır' },
    { id: '6612', name: 'Kadışehri' },
    { id: '6613', name: 'Saraykent' },
    { id: '6614', name: 'Yenifakılı' },
  ],
  '67': [
    { id: '6701', name: 'Zonguldak Merkez' },
    { id: '6702', name: 'Çaycuma' },
    { id: '6703', name: 'Devrek' },
    { id: '6704', name: 'Ereğli' },
    { id: '6705', name: 'Alaplı' },
    { id: '6706', name: 'Gökçebey' },
  ],
  '68': [
    { id: '6801', name: 'Aksaray Merkez' },
    { id: '6802', name: 'Ortaköy' },
    { id: '6803', name: 'Ağaçören' },
    { id: '6804', name: 'Güzelyurt' },
    { id: '6805', name: 'Sarıyahşi' },
    { id: '6806', name: 'Eskil' },
    { id: '6807', name: 'Gülağaç' },
  ],
  '69': [
    { id: '6901', name: 'Bayburt Merkez' },
    { id: '6902', name: 'Aydıntepe' },
    { id: '6903', name: 'Demirözü' },
  ],
  '70': [
    { id: '7001', name: 'Karaman Merkez' },
    { id: '7002', name: 'Ermenek' },
    { id: '7003', name: 'Kazımkarabekir' },
    { id: '7004', name: 'Ayrancı' },
    { id: '7005', name: 'Sarıveliler' },
    { id: '7006', name: 'Başyayla' },
  ],
  '71': [
    { id: '7101', name: 'Kırıkkale Merkez' },
    { id: '7102', name: 'Delice' },
    { id: '7103', name: 'Keskin' },
    { id: '7104', name: 'Sulakyurt' },
    { id: '7105', name: 'Bahşılı' },
    { id: '7106', name: 'Balışeyh' },
    { id: '7107', name: 'Çelebi' },
    { id: '7108', name: 'Karakeçili' },
    { id: '7109', name: 'Yahşihan' },
  ],
  '72': [
    { id: '7201', name: 'Batman Merkez' },
    { id: '7202', name: 'Beşiri' },
    { id: '7203', name: 'Gercüş' },
    { id: '7204', name: 'Kozluk' },
    { id: '7205', name: 'Sason' },
    { id: '7206', name: 'Hasankeyf' },
  ],
  '73': [
    { id: '7301', name: 'Şırnak Merkez' },
    { id: '7302', name: 'Cizre' },
    { id: '7303', name: 'İdil' },
    { id: '7304', name: 'Silopi' },
    { id: '7305', name: 'Beytüşşebap' },
    { id: '7306', name: 'Güçlükonak' },
    { id: '7307', name: 'Uludere' },
  ],
  '74': [
    { id: '7401', name: 'Bartın Merkez' },
    { id: '7402', name: 'Kurucaşile' },
    { id: '7403', name: 'Ulus' },
    { id: '7404', name: 'Amasra' },
  ],
  '75': [
    { id: '7501', name: 'Ardahan Merkez' },
    { id: '7502', name: 'Çıldır' },
    { id: '7503', name: 'Göle' },
    { id: '7504', name: 'Hanak' },
    { id: '7505', name: 'Posof' },
    { id: '7506', name: 'Damal' },
  ],
  '76': [
    { id: '7601', name: 'Iğdır Merkez' },
    { id: '7602', name: 'Aralık' },
    { id: '7603', name: 'Tuzluca' },
    { id: '7604', name: 'Karakoyunlu' },
  ],
  '77': [
    { id: '7701', name: 'Yalova Merkez' },
    { id: '7702', name: 'Altınova' },
    { id: '7703', name: 'Armutlu' },
    { id: '7704', name: 'Çınarcık' },
    { id: '7705', name: 'Çiftlikköy' },
    { id: '7706', name: 'Termal' },
  ],
  '78': [
    { id: '7801', name: 'Karabük Merkez' },
    { id: '7802', name: 'Eflani' },
    { id: '7803', name: 'Eskipazar' },
    { id: '7804', name: 'Ovacık' },
    { id: '7805', name: 'Safranbolu' },
    { id: '7806', name: 'Yenice' },
  ],
  '79': [
    { id: '7901', name: 'Kilis Merkez' },
    { id: '7902', name: 'Elbeyli' },
    { id: '7903', name: 'Musabeyli' },
    { id: '7904', name: 'Polateli' },
  ],
  '80': [
    { id: '8001', name: 'Osmaniye Merkez' },
    { id: '8002', name: 'Bahçe' },
    { id: '8003', name: 'Kadirli' },
    { id: '8004', name: 'Düziçi' },
    { id: '8005', name: 'Hasanbeyli' },
    { id: '8006', name: 'Sumbas' },
    { id: '8007', name: 'Toprakkale' },
  ],
  '81': [
    { id: '8101', name: 'Düzce Merkez' },
    { id: '8102', name: 'Akçakoca' },
    { id: '8103', name: 'Yığılca' },
    { id: '8104', name: 'Cumayeri' },
    { id: '8105', name: 'Gölyaka' },
    { id: '8106', name: 'Çilimli' },
    { id: '8107', name: 'Gümüşova' },
    { id: '8108', name: 'Kaynaşlı' },
  ],
};

// --- Önemli Mekan Verileri ---
export const tumMekanlar = [
  { ad: 'Ayasofya Camii', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0085, longitude: 28.9801, bilgi: 'Bizans ve Osmanlı mimarisinin görkemli birleşimi, dünya mimarlık tarihinin başyapıtlarından biri.' },
  { ad: 'Sultanahmet Camii', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0054, longitude: 28.9768, bilgi: 'Altı minaresi ve İznik çinileriyle ünlü, "Mavi Cami" olarak da bilinen anıtsal yapı.' },
  { ad: 'Topkapı Sarayı Müzesi', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0116, longitude: 28.9834, bilgi: 'Osmanlı İmparatorluğu\'nun 400 yıl boyunca idare merkezi olan, avlular ve köşklerden oluşan devasa kompleks.' },
  { ad: 'Dolmabahçe Sarayı', il: 'İstanbul', ilce: 'Beşiktaş', latitude: 41.0392, longitude: 29.0003, bilgi: 'Batılılaşma etkisindeki Osmanlı mimarisinin en görkemli örneği, Atatürk\'ün hayata gözlerini yumduğu yer.' },
  { ad: 'Galata Kulesi', il: 'İstanbul', ilce: 'Beyoğlu', latitude: 41.0256, longitude: 28.9742, bilgi: 'Cenevizlilerden kalma, İstanbul\'un panoramik manzarasını sunan tarihi taş kule.' },
  { ad: 'Kız Kulesi', il: 'İstanbul', ilce: 'Üsküdar', latitude: 41.0211, longitude: 29.0042, bilgi: 'Boğaz\'ın ortasında yer alan, hakkında birçok efsane anlatılan İstanbul\'un ikonik simgesi.' },
  { ad: 'Süleymaniye Camii', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0162, longitude: 28.9644, bilgi: 'Mimar Sinan\'ın "kalfalık eserim" dediği, Kanuni Sultan Süleyman adına yaptırılmış muhteşem külliye.' },
  { ad: 'Rumeli Hisarı', il: 'İstanbul', ilce: 'Sarıyer', latitude: 41.0858, longitude: 29.0569, bilgi: 'Fatih Sultan Mehmet tarafından İstanbul\'un fethi için Boğaz\'ın en dar yerine inşa ettirilen görkemli kale.' },
  { ad: 'Yerebatan Sarnıcı', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0083, longitude: 28.9779, bilgi: 'Bizans döneminden kalma, Medusa başı sütunları ve loş atmosferiyle büyüleyici bir yeraltı su sarnıcı.' },
  { ad: 'Ortaköy Camii (Büyük Mecidiye Camii)', il: 'İstanbul', ilce: 'Beşiktaş', latitude: 41.0475, longitude: 29.0233, bilgi: 'Boğaziçi\'nin en zarif yapılarından, Barok ve Neoklasik tarzların birleşimi olan estetik cami.' },
  { ad: 'Efes Antik Kenti', il: 'İzmir', ilce: 'Selçuk', latitude: 37.9415, longitude: 27.3426, bilgi: 'Antik dünyanın en önemli metropollerinden biri, Celsus Kütüphanesi ve Büyük Tiyatro gibi yapılarıyla ünlü.' },
  { ad: 'İzmir Saat Kulesi', il: 'İzmir', ilce: 'Konak', latitude: 38.4189, longitude: 27.1287, bilgi: 'Konak Meydanı\'nda yer alan, II. Abdülhamit\'in hediyesi olan zarif ve şehrin simgesi haline gelmiş kule.' },
  { ad: 'Bergama Antik Kenti (Pergamon)', il: 'İzmir', ilce: 'Bergama', latitude: 39.1214, longitude: 27.1825, bilgi: 'Parşömenin icat edildiği yer olarak bilinen, Akropol, Asklepion ve Kızıl Avlu gibi önemli kalıntılara sahip antik kent.' },
  { ad: 'Pamukkale Travertenleri', il: 'Denizli', ilce: 'Pamukkale', latitude: 37.9234, longitude: 29.1218, bilgi: 'Termal suların oluşturduğu bembeyaz traverten terasları ve Hierapolis Antik Kenti ile UNESCO Dünya Mirası.' },
  { ad: 'Göreme Açık Hava Müzesi', il: 'Nevşehir', ilce: 'Nevşehir Merkez', latitude: 38.6432, longitude: 34.8298, bilgi: 'Kapadokya\'nın kalbinde yer alan, kayalara oyulmuş kiliseler ve manastırlarla dolu eşsiz bir kompleks.' },
  { ad: 'Sümela Manastırı', il: 'Trabzon', ilce: 'Maçka', latitude: 40.6903, longitude: 39.6582, bilgi: 'Karadağ\'ın sarp bir yamacına inşa edilmiş, nefes kesen manzarasıyla ünlü tarihi Rum Ortodoks manastırı.' },
  { ad: 'Göbeklitepe', il: 'Şanlıurfa', ilce: 'Haliliye', latitude: 37.2233, longitude: 38.9225, bilgi: 'Tarihin sıfır noktası olarak kabul edilen, dünyanın bilinen en eski tapınak kompleksi.' },
  { ad: 'Nemrut Dağı', il: 'Adıyaman', ilce: 'Kahta', latitude: 37.9811, longitude: 38.7397, bilgi: 'Kommagene Krallığı\'na ait, devasa heykellerin bulunduğu gizemli ve büyüleyici bir arkeolojik alan.' },
  { ad: 'Ulu Cami', il: 'Bursa', ilce: 'Osmangazi', latitude: 40.1843, longitude: 29.0615, bilgi: 'Erken Osmanlı mimarisinin en büyük ve en görkemli camisi, hat sanatının eşsiz örneklerini barındırır.' },
  { ad: 'Selimiye Camii', il: 'Edirne', ilce: 'Edirne Merkez', latitude: 41.6783, longitude: 26.5594, bilgi: 'Mimar Sinan\'ın "ustalık eserim" dediği, Osmanlı mimarisinin zirvesi kabul edilen anıtsal yapı.' },
  { ad: 'Mevlana Müzesi', il: 'Konya', ilce: 'Karatay', latitude: 37.8713, longitude: 32.5052, bilgi: 'Mevlana Celaleddin Rumi\'nin türbesinin bulunduğu, her yıl milyonlarca kişinin ziyaret ettiği manevi bir merkez.' },
  { ad: 'Kaleiçi', il: 'Antalya', ilce: 'Muratpaşa', latitude: 36.8848, longitude: 30.7054, bilgi: 'Antalya\'nın tarihi merkezi; dar sokakları, cumbalı evleri ve Hadrian Kapısı ile şehrin ruhunu yansıtır.' },
  { ad: 'İshak Paşa Sarayı', il: 'Ağrı', ilce: 'Doğubayazıt', latitude: 39.5250, longitude: 44.0833, bilgi: 'Osmanlı, Fars ve Selçuklu mimarisinin izlerini taşıyan, bir tepenin üzerine kurulmuş masalsı saray.' },
  { ad: 'Taşköprü', il: 'Adana', ilce: 'Seyhan', latitude: 36.9851, longitude: 35.3323, bilgi: 'Roma döneminden kalma, dünyanın kullanılan en eski köprülerinden biri olarak kabul edilen tarihi yapı.' },
  { ad: 'Afyon Kalesi', il: 'Afyonkarahisar', ilce: 'Afyonkarahisar Merkez', latitude: 38.7583, longitude: 30.5386, bilgi: 'Volkanik bir kaya kütlesi üzerine kurulmuş, şehre hakim manzarasıyla etkileyici bir kale.' },
  { ad: 'Kral Kaya Mezarları', il: 'Amasya', ilce: 'Amasya Merkez', latitude: 40.6517, longitude: 35.8353, bilgi: 'Yeşilırmak kenarındaki Harşena Dağı\'nın eteklerine oyulmuş, Pontus krallarına ait anıtsal mezarlar.' },
  { ad: 'Karagöl Sahara Milli Parkı', il: 'Artvin', ilce: 'Şavşat', latitude: 41.2581, longitude: 42.3433, bilgi: 'Eşsiz doğal güzellikleri, yemyeşil ormanları ve buzul gölleri ile bir doğa harikası.' },
  { ad: 'Apollon Tapınağı', il: 'Aydın', ilce: 'Didim', latitude: 37.3847, longitude: 27.2783, bilgi: 'Antik dünyanın en büyük kehanet merkezlerinden biri olan, devasa sütunlarıyla etkileyici bir tapınak.' },
  { ad: 'Şeytan Sofrası', il: 'Balıkesir', ilce: 'Ayvalık', latitude: 39.3242, longitude: 26.6961, bilgi: 'Ayvalık adalarına hakim, özellikle gün batımında sunduğu panoramik manzarasıyla ünlü bir tepe.' },
  { ad: 'Şeyh Edebali Türbesi', il: 'Bilecik', ilce: 'Bilecik Merkez', latitude: 40.1419, longitude: 29.9796, bilgi: 'Osmanlı Devleti\'nin manevi kurucusu Şeyh Edebali\'nin türbesinin bulunduğu tarihi ve manevi bir mekan.' },
  { ad: 'Yüzen Adalar', il: 'Bingöl', ilce: 'Solhan', latitude: 38.9353, longitude: 41.1342, bilgi: 'Krater gölü üzerinde rüzgarla hareket eden üç adacıktan oluşan, ender rastlanan bir doğa olayı.' },
  { ad: 'Ahlat Selçuklu Mezarlığı', il: 'Bitlis', ilce: 'Ahlat', latitude: 38.7569, longitude: 42.4981, bilgi: 'Anadolu\'daki en büyük tarihi mezarlık, "şahit taşları" olarak bilinen anıtsal mezar taşlarıyla ünlü.' },
  { ad: 'Gölcük Tabiat Parkı', il: 'Bolu', ilce: 'Bolu Merkez', latitude: 40.6975, longitude: 31.6219, bilgi: 'Göl kenarındaki Devlet Konukevi\'nin yansımasıyla kartpostallık manzaralar sunan, huzurlu bir doğa alanı.' },
  { ad: 'Sagalassos Antik Kenti', il: 'Burdur', ilce: 'Ağlasun', latitude: 37.6775, longitude: 30.5203, bilgi: 'Torosların güney yamacında yer alan, Antoninler Çeşmesi gibi görkemli yapılarıyla etkileyici bir Roma kenti.' },
  { ad: 'Truva Antik Kenti', il: 'Çanakkale', ilce: 'Çanakkale Merkez', latitude: 39.9575, longitude: 26.2389, bilgi: 'Homeros\'un İlyada destanına konu olan, 9 katmandan oluşan efsanevi antik şehir.' },
  { ad: 'Çankırı Kalesi', il: 'Çankırı', ilce: 'Çankırı Merkez', latitude: 39.9028, longitude: 33.6167, bilgi: 'Şehre hakim bir tepe üzerinde bulunan, tarihi ve manzarasıyla öne çıkan bir kale.' },
  { ad: 'Hattuşa Antik Kenti', il: 'Çorum', ilce: 'Boğazkale', latitude: 40.0203, longitude: 34.6150, bilgi: 'Hitit İmparatorluğu\'nun başkenti olan, Aslanlı Kapı ve Yazılıkaya gibi anıtsal yapılarıyla UNESCO mirası.' },
  { ad: 'Diyarbakır Surları', il: 'Diyarbakır', ilce: 'Sur', latitude: 37.9103, longitude: 40.2281, bilgi: 'Çin Seddi\'nden sonra dünyanın en uzun ve en iyi korunmuş surları olarak bilinen anıtsal yapı.' },
  { ad: 'Harput Kalesi', il: 'Elazığ', ilce: 'Elazığ Merkez', latitude: 38.7067, longitude: 39.2458, bilgi: 'Urartulardan Osmanlılara kadar birçok medeniyete ev sahipliği yapmış, "Süt Kalesi" olarak da bilinir.' },
  { ad: 'Girlevik Şelalesi', il: 'Erzincan', ilce: 'Erzincan Merkez', latitude: 39.5333, longitude: 39.6333, bilgi: 'Doğal güzelliği ve serin havasıyla özellikle yaz aylarında popüler olan, katmanlı bir şelale.' },
  { ad: 'Çifte Minareli Medrese', il: 'Erzurum', ilce: 'Yakutiye', latitude: 39.9056, longitude: 41.2758, bilgi: 'Selçuklu mimarisinin en görkemli örneklerinden, Anadolu\'nun en büyük medresesi.' },
  { ad: 'Odunpazarı Evleri', il: 'Eskişehir', ilce: 'Odunpazarı', latitude: 39.7667, longitude: 30.5256, bilgi: 'Kıvrımlı yolları, çıkmaz sokakları ve renkli cumbalı evleri ile Osmanlı sivil mimarisinin en güzel örnekleri.' },
  { ad: 'Zeugma Mozaik Müzesi', il: 'Gaziantep', ilce: 'Şehitkamil', latitude: 37.0708, longitude: 37.3853, bilgi: 'Dünyanın en büyük mozaik müzelerinden biri, özellikle "Çingene Kızı" mozaiği ile ünlüdür.' },
  { ad: 'Giresun Kalesi', il: 'Giresun', ilce: 'Giresun Merkez', latitude: 40.9167, longitude: 38.3833, bilgi: 'Şehrin merkezinde, Karadeniz\'e hakim bir tepe üzerinde yer alan, panoramik manzaralı bir kale.' },
  { ad: 'Karaca Mağarası', il: 'Gümüşhane', ilce: 'Torul', latitude: 40.5058, longitude: 39.3814, bilgi: 'Damlataşı oluşumlarının zenginliği ve renk cümbüşü ile adeta bir yeraltı sarayını andıran mağara.' },
  { ad: 'Cennet-Cehennem Mağaraları', il: 'Mersin', ilce: 'Silifke', latitude: 36.4447, longitude: 34.1092, bilgi: 'Mitolojik hikayelere konu olan, yeraltı sularının oluşturduğu iki büyük obruk.' },
  { ad: 'Aziz Petrus Kilisesi', il: 'Hatay', ilce: 'Antakya', latitude: 36.2167, longitude: 36.1833, bilgi: 'Hristiyanlık kelimesinin ilk kez kullanıldığına inanılan, dünyanın ilk Katolik kilisesi olarak kabul edilen mağara kilise.' },
  { ad: 'Eğirdir Gölü', il: 'Isparta', ilce: 'Eğirdir', latitude: 37.8667, longitude: 30.8833, bilgi: 'Gün içinde farklı renklere bürünen, Yeşil Ada ve Can Ada gibi güzellikleri barındıran tektonik bir göl.' },
  { ad: 'Ani Harabeleri', il: 'Kars', ilce: 'Kars Merkez', latitude: 40.5064, longitude: 43.5725, bilgi: 'Binbir kiliseli şehir olarak anılan, farklı medeniyetlere ait mimari yapıların bir arada bulunduğu etkileyici antik kent.' },
  { ad: 'Kastamonu Kalesi', il: 'Kastamonu', ilce: 'Kastamonu Merkez', latitude: 41.3764, longitude: 33.7769, bilgi: 'Şehrin simgesi olan, Bizans döneminden kalma ve şehre hakim bir noktada bulunan tarihi kale.' },
  { ad: 'Erciyes Dağı', il: 'Kayseri', ilce: 'Melikgazi', latitude: 38.5322, longitude: 35.4922, bilgi: 'Türkiye\'nin en önemli kış turizmi merkezlerinden biri olan, zirvesi her zaman karlı sönmüş bir volkan.' },
  { ad: 'Dupnisa Mağarası', il: 'Kırklareli', ilce: 'Demirköy', latitude: 41.8542, longitude: 27.5619, bilgi: 'İçinden nehir geçen, yarasaları ve milyonlarca yıllık sarkıt ve dikitleri ile Trakya\'nın tek turizme açık mağarası.' },
  { ad: 'Ahi Evran Camii ve Türbesi', il: 'Kırşehir', ilce: 'Kırşehir Merkez', latitude: 39.1461, longitude: 34.1611, bilgi: 'Ahilik teşkilatının kurucusu Ahi Evran\'ın türbesinin bulunduğu, manevi öneme sahip bir kompleks.' },
  { ad: 'Saat Kulesi', il: 'Kocaeli', ilce: 'İzmit', latitude: 40.7628, longitude: 29.9194, bilgi: 'Sultan II. Abdülhamit\'in tahta çıkışının 25. yılı anısına yaptırılan, İzmit\'in sembol yapılarından biri.' },
  { ad: 'Aizanoi Antik Kenti', il: 'Kütahya', ilce: 'Çavdarhisar', latitude: 39.2053, longitude: 29.6106, bilgi: 'Anadolu\'daki en iyi korunmuş Zeus Tapınağı\'na ev sahipliği yapan, "İkinci Efes" olarak anılan antik kent.' },
  { ad: 'Aslantepe Höyüğü', il: 'Malatya', ilce: 'Battalgazi', latitude: 38.3861, longitude: 38.3183, bilgi: 'Anadolu\'daki ilk şehir devletinin kurulduğu yer olarak kabul edilen, UNESCO Dünya Mirası listesindeki höyük.' },
  { ad: 'Sardes Antik Kenti', il: 'Manisa', ilce: 'Salihli', latitude: 38.4878, longitude: 28.0397, bilgi: 'Lidya Krallığı\'nın başkenti olan ve paranın ilk basıldığı yer olarak bilinen tarihi kent.' },
  { ad: 'Deyrulzafaran Manastırı', il: 'Mardin', ilce: 'Artuklu', latitude: 37.2917, longitude: 40.7819, bilgi: 'Süryani Kadim cemaatinin en önemli merkezlerinden biri, 5. yüzyıldan kalma görkemli bir yapı.' },
  { ad: 'Ölüdeniz', il: 'Muğla', ilce: 'Fethiye', latitude: 36.5458, longitude: 29.1239, bilgi: 'Durgun suyu ve eşsiz kumsalıyla dünyanın en güzel plajlarından biri olarak kabul edilen bir lagün.' },
  { ad: 'Malazgirt Kalesi', il: 'Muş', ilce: 'Malazgirt', latitude: 39.1469, longitude: 42.5403, bilgi: '1071 Malazgirt Meydan Muharebesi\'nin geçtiği topraklarda yer alan tarihi öneme sahip kale.' },
  { ad: 'Gümüşler Manastırı', il: 'Niğde', ilce: 'Niğde Merkez', latitude: 38.0167, longitude: 34.6, bilgi: 'Büyük bir kaya kütlesinin içine oyulmuş, gülümseyen Meryem Ana freski ile ünlü manastır.' },
  { ad: 'Boztepe', il: 'Ordu', ilce: 'Altınordu', latitude: 40.9833, longitude: 37.8833, bilgi: 'Teleferikle çıkılan, Ordu şehrini ve Karadeniz\'i panoramik olarak izleme imkanı sunan bir tepe.' },
  { ad: 'Ayder Yaylası', il: 'Rize', ilce: 'Çamlıhemşin', latitude: 40.9419, longitude: 41.1169, bilgi: 'Kaçkar Dağları\'nın eteğinde, kaplıcaları ve yemyeşil doğasıyla ünlü bir yayla.' },
  { ad: 'Justinianus Köprüsü', il: 'Sakarya', ilce: 'Serdivan', latitude: 40.7811, longitude: 30.3408, bilgi: 'Erken Bizans döneminden kalma, 365 metre uzunluğundaki görkemli taş köprü.' },
  { ad: 'Şahinkaya Kanyonu', il: 'Samsun', ilce: 'Vezirköprü', latitude: 41.0964, longitude: 35.2525, bilgi: 'Kızılırmak üzerinde yer alan, sarp kayalıkları ve turkuaz sularıyla büyüleyici bir doğa harikası.' },
  { ad: 'Veysel Karani Türbesi', il: 'Siirt', ilce: 'Baykan', latitude: 38.2325, longitude: 41.7772, bilgi: 'İslam peygamberi Muhammed\'in hırkasını verdiği Veysel Karani\'nin türbesi, önemli bir inanç merkezi.' },
  { ad: 'Tarihi Sinop Cezaevi', il: 'Sinop', ilce: 'Sinop Merkez', latitude: 42.0294, longitude: 35.1539, bilgi: 'Birçok ünlü yazar ve düşünürün kaldığı, "Anadolu\'nun Alkatrazı" olarak bilinen tarihi yapı.' },
  { ad: 'Divriği Ulu Camii ve Darüşşifası', il: 'Sivas', ilce: 'Divriği', latitude: 39.3736, longitude: 38.1225, bilgi: 'Taş işçiliğinin eşsiz örneklerini barındıran, UNESCO Dünya Mirası listesindeki mimari harikası.' },
  { ad: 'Rüstem Paşa Külliyesi', il: 'Tekirdağ', ilce: 'Süleymanpaşa', latitude: 40.9786, longitude: 27.5103, bilgi: 'Mimar Sinan tarafından yapılan, cami, bedesten ve medreseden oluşan klasik Osmanlı kompleksi.' },
  { ad: 'Ballıca Mağarası', il: 'Tokat', ilce: 'Pazar', latitude: 40.3014, longitude: 36.2158, bilgi: 'Soğan sarkıtları gibi dünyada ender görülen oluşumlara sahip, 8 salonu gezilebilen büyük bir mağara.' },
  { ad: 'Munzur Vadisi Milli Parkı', il: 'Tunceli', ilce: 'Ovacık', latitude: 39.3333, longitude: 39.5, bilgi: 'Zengin bitki örtüsü ve yaban hayatı ile Türkiye\'nin en büyük milli parklarından biri.' },
  { ad: 'Blaundus Antik Kenti', il: 'Uşak', ilce: 'Ulubey', latitude: 38.4167, longitude: 29.2833, bilgi: 'Büyük İskender döneminde kurulmuş, derin bir kanyonun kenarında yer alan etkileyici antik kent.' },
  { ad: 'Van Kalesi', il: 'Van', ilce: 'Tuşba', latitude: 38.5022, longitude: 43.3333, bilgi: 'Urartu Krallığı tarafından yaptırılan, Van Gölü\'ne hakim bir tepe üzerindeki görkemli kale.' },
  { ad: 'Yozgat Saat Kulesi', il: 'Yozgat', ilce: 'Yozgat Merkez', latitude: 39.8211, longitude: 34.8086, bilgi: 'Şehrin merkezinde yer alan, kesme taştan yapılmış, Yozgat\'ın simgesi haline gelmiş tarihi yapı.' },
  { ad: 'Cehennemağzı Mağaraları', il: 'Zonguldak', ilce: 'Ereğli', latitude: 41.2828, longitude: 31.4194, bilgi: 'Antik dönemde kehanet merkezi olduğuna inanılan ve mitolojide Herkül\'ün görevlerinden birinin geçtiği yer.' },
  { ad: 'Ihlara Vadisi', il: 'Aksaray', ilce: 'Güzelyurt', latitude: 38.2503, longitude: 34.3056, bilgi: 'Melendiz Çayı\'nın oluşturduğu, duvarlarına oyulmuş yüzlerce kilise ve yaşam alanıyla doğa ve tarihin buluştuğu kanyon.' },
  { ad: 'Bayburt Kalesi', il: 'Bayburt', ilce: 'Bayburt Merkez', latitude: 40.2583, longitude: 40.2222, bilgi: 'Tarihi İpek Yolu üzerinde yer alan, Çoruh Nehri\'ne bakan sarp bir kayalık üzerine kurulmuş kale.' },
  { ad: 'Karaman Kalesi', il: 'Karaman', ilce: 'Karaman Merkez', latitude: 37.1811, longitude: 33.2181, bilgi: 'Şehrin merkezinde bulunan, Karamanoğulları Beyliği\'nin en önemli yapılarından biri olan tarihi kale.' },
  { ad: 'Ceritkale Kaya Mezarları', il: 'Kırıkkale', ilce: 'Keskin', latitude: 39.6739, longitude: 33.8183, bilgi: 'Roma dönemine ait olduğu düşünülen, sarp bir kaya yüzeyine oyulmuş etkileyici mezarlar.' },
  { ad: 'Hasankeyf Kalesi', il: 'Batman', ilce: 'Hasankeyf', latitude: 37.7167, longitude: 41.4167, bilgi: 'Ilısu Barajı suları altında kalmadan önce Dicle Nehri\'ne bakan, binlerce yıllık tarihe sahip antik kent ve kale.' },
  { ad: 'Cizre Ulu Camii', il: 'Şırnak', ilce: 'Cizre', latitude: 37.3278, longitude: 42.1869, bilgi: 'Ejder figürlü kapı tokmakları ile ünlü, Artuklu dönemine ait önemli bir mimari eser.' },
  { ad: 'Amasra Kalesi', il: 'Bartın', ilce: 'Amasra', latitude: 41.7486, longitude: 32.3853, bilgi: 'Roma, Bizans ve Ceneviz dönemlerinin izlerini taşıyan, yarımada üzerine kurulmuş tarihi kale.' },
  { ad: 'Çıldır Gölü', il: 'Ardahan', ilce: 'Çıldır', latitude: 41.0333, longitude: 43.25, bilgi: 'Doğu Anadolu\'nun en büyük ikinci gölü, kışın yüzeyi tamamen donar ve üzerinde atlı kızakla gezilir.' },
  { ad: 'Ağrı Dağı Milli Parkı', il: 'Iğdır', ilce: 'Iğdır Merkez', latitude: 39.7025, longitude: 44.2936, bilgi: 'Türkiye\'nin en yüksek dağı olan Ağrı Dağı\'nı ve Nuh\'un Gemisi\'nin izlerini barındırdığına inanılan bölge.' },
  { ad: 'Yürüyen Köşk', il: 'Yalova', ilce: 'Yalova Merkez', latitude: 40.6586, longitude: 29.2961, bilgi: 'Atatürk\'ün bir çınar ağacının dalını kesmemek için binanın temelini kaydırdığı, çevre bilincinin sembolü olan köşk.' },
  { ad: 'Safranbolu Evleri', il: 'Karabük', ilce: 'Safranbolu', latitude: 41.2444, longitude: 32.6903, bilgi: 'Geleneksel Osmanlı sivil mimarisinin en iyi korunduğu, UNESCO Dünya Mirası listesindeki tarihi ilçe.' },
  { ad: 'Ravanda Kalesi', il: 'Kilis', ilce: 'Kilis Merkez', latitude: 36.7833, longitude: 37.2, bilgi: 'İslamiyet öncesi döneme tarihlenen, stratejik bir konumda bulunan ve Afrin Çayı\'na bakan kale.' },
  { ad: 'Karatepe-Aslantaş Açık Hava Müzesi', il: 'Osmaniye', ilce: 'Kadirli', latitude: 37.2917, longitude: 36.25, bilgi: 'Geç Hitit dönemine ait kalıntıları, Fenike ve Luvice yazıtları barındıran önemli bir arkeolojik alan.' },
  { ad: 'Ayasofya Camii', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0085, longitude: 28.9801, bilgi: 'Bizans ve Osmanlı mimarisinin görkemli birleşimi...' },
  { ad: 'Sultanahmet Camii', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0054, longitude: 28.9768, bilgi: 'Mavi Camii olarak da bilinir...' },
  { ad: 'Topkapı Sarayı', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0116, longitude: 28.9834, bilgi: 'Osmanlı padişahlarının ikametgahı...' },
  { ad: 'Yerebatan Sarnıcı', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0079, longitude: 28.9772, bilgi: 'Bizans dönemi yeraltı su deposu.' },
  { ad: 'Kapalıçarşı', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0107, longitude: 28.9675, bilgi: 'Dünyanın en eski ve en büyük kapalı çarşılarından biri.' },
  { ad: 'Ortaköy Camii', il: 'İstanbul', ilce: 'Beşiktaş', latitude: 41.0478, longitude: 29.0253, bilgi: 'Boğaz kenarında zarif bir Osmanlı camii.' },
  { ad: 'Dolmabahçe Sarayı', il: 'İstanbul', ilce: 'Beşiktaş', latitude: 41.0396, longitude: 29.0069, bilgi: 'Osmanlı İmparatorluğu\'nun son dönem sarayı.' },
  { ad: 'Kız Kulesi', il: 'İstanbul', ilce: 'Üsküdar', latitude: 41.0210, longitude: 29.0042, bilgi: 'Boğaz\'ın ortasında efsanelere konu olmuş tarihi kule.' },
  { ad: 'Güzeldere Şelalesi Tabiat Parkı', il: 'Düzce', ilce: 'Gölyaka', latitude: 40.7167, longitude: 31.0167, bilgi: '130 metre yükseklikten dökülen suyu ve etrafındaki zengin bitki örtüsüyle bir doğa harikası.' },
  { ad: 'Pamukkale Travertenleri ve Hierapolis', il: 'Denizli', ilce: 'Pamukkale', latitude: 37.9234, longitude: 29.1218, bilgi: 'Termal suların oluşturduğu bembeyaz traverten terasları ve Hierapolis Antik Kenti ile UNESCO Dünya Mirası.' },
  { ad: 'Göreme Açık Hava Müzesi', il: 'Nevşehir', ilce: 'Nevşehir Merkez', latitude: 38.6432, longitude: 34.8298, bilgi: 'Kapadokya\'nın kalbinde yer alan, kayalara oyulmuş kiliseler ve manastırlarla dolu eşsiz bir kompleks.' },
  { ad: 'Ulu Cami', il: 'Bursa', ilce: 'Osmangazi', latitude: 40.1843, longitude: 29.0615, bilgi: 'Erken Osmanlı mimarisinin en büyük ve en görkemli camisi, hat sanatının eşsiz örneklerini barındırır.' },
  { ad: 'Selimiye Camii', il: 'Edirne', ilce: 'Edirne Merkez', latitude: 41.6783, longitude: 26.5594, bilgi: 'Mimar Sinan\'ın "ustalık eserim" dediği, Osmanlı mimarisinin zirvesi kabul edilen anıtsal yapı.' },
  { ad: 'Mevlana Müzesi', il: 'Konya', ilce: 'Karatay', latitude: 37.8713, longitude: 32.5052, bilgi: 'Mevlana Celaleddin Rumi\'nin türbesinin bulunduğu, her yıl milyonlarca kişinin ziyaret ettiği manevi bir merkez.' },
  { ad: 'Sümela Manastırı', il: 'Trabzon', ilce: 'Maçka', latitude: 40.6903, longitude: 39.6582, bilgi: 'Karadağ\'ın sarp bir yamacına inşa edilmiş, nefes kesen manzarasıyla ünlü tarihi Rum Ortodoks manastırı.' },
  { ad: 'Göbeklitepe', il: 'Şanlıurfa', ilce: 'Haliliye', latitude: 37.2233, longitude: 38.9225, bilgi: 'Tarihin sıfır noktası olarak kabul edilen, dünyanın bilinen en eski tapınak kompleksi.' },
  { ad: 'Nemrut Dağı Heykelleri', il: 'Adıyaman', ilce: 'Kahta', latitude: 37.9811, longitude: 38.7397, bilgi: 'Kommagene Krallığı\'na ait, devasa heykellerin bulunduğu gizemli ve büyüleyici bir arkeolojik alan.' },
  { ad: 'İshak Paşa Sarayı', il: 'Ağrı', ilce: 'Doğubayazıt', latitude: 39.5250, longitude: 44.0833, bilgi: 'Osmanlı, Fars ve Selçuklu mimarisinin izlerini taşıyan, bir tepenin üzerine kurulmuş masalsı saray.' },
  { ad: 'Zeugma Mozaik Müzesi', il: 'Gaziantep', ilce: 'Şehitkamil', latitude: 37.0708, longitude: 37.3853, bilgi: 'Dünyanın en büyük mozaik müzelerinden biri, özellikle "Çingene Kızı" mozaiği ile ünlüdür.' },
  { ad: 'Alanya Kalesi', il: 'Antalya', ilce: 'Alanya', latitude: 36.5333, longitude: 31.9944, bilgi: 'Selçuklu döneminden kalma, yarımada üzerine kurulu, Kızıl Kule ve tersanesi ile bir bütün olan görkemli kale.' },
  { ad: 'Aspendos Tiyatrosu', il: 'Antalya', ilce: 'Serik', latitude: 36.9389, longitude: 31.1719, bilgi: 'Roma döneminden kalma, dünyadaki en iyi korunmuş antik tiyatrolardan biri.' },
  { ad: 'Bodrum Kalesi ve Sualtı Arkeoloji Müzesi', il: 'Muğla', ilce: 'Bodrum', latitude: 37.0319, longitude: 27.4292, bilgi: 'St. Jean Şövalyeleri tarafından inşa edilen, günümüzde önemli bir sualtı arkeoloji müzesine ev sahipliği yapan kale.' },
  { ad: 'Divriği Ulu Camii ve Darüşşifası', il: 'Sivas', ilce: 'Divriği', latitude: 39.3736, longitude: 38.1225, bilgi: 'Taş işçiliğinin eşsiz ve abartılı örneklerini barındıran, UNESCO Dünya Mirası listesindeki mimari harikası.' },
  { ad: 'Hattuşa Antik Kenti', il: 'Çorum', ilce: 'Boğazkale', latitude: 40.0203, longitude: 34.6150, bilgi: 'Hitit İmparatorluğu\'nun başkenti olan, Aslanlı Kapı ve Yazılıkaya gibi anıtsal yapılarıyla UNESCO mirası.' },
  { ad: 'Ani Harabeleri', il: 'Kars', ilce: 'Kars Merkez', latitude: 40.5064, longitude: 43.5725, bilgi: 'Binbir kiliseli şehir olarak anılan, farklı medeniyetlere ait mimari yapıların bir arada bulunduğu etkileyici antik kent.' },
  { ad: 'Malabadi Köprüsü', il: 'Diyarbakır', ilce: 'Silvan', latitude: 38.1561, longitude: 41.2181, bilgi: 'Artuklular döneminden kalma, taş köprüler içinde kemeri en geniş olanı olarak bilinen mimari şaheser.' },
  { ad: 'Deyrulzafaran Manastırı', il: 'Mardin', ilce: 'Artuklu', latitude: 37.2917, longitude: 40.7819, bilgi: 'Süryani Kadim cemaatinin en önemli merkezlerinden biri, 5. yüzyıldan kalma görkemli bir yapı.' },
  { ad: 'Safranbolu Evleri', il: 'Karabük', ilce: 'Safranbolu', latitude: 41.2444, longitude: 32.6903, bilgi: 'Geleneksel Osmanlı sivil mimarisinin en iyi korunduğu, UNESCO Dünya Mirası listesindeki tarihi ilçe.' },
  { ad: 'Truva Antik Kenti', il: 'Çanakkale', ilce: 'Çanakkale Merkez', latitude: 39.9575, longitude: 26.2389, bilgi: 'Homeros\'un İlyada destanına konu olan, 9 katmandan oluşan efsanevi antik şehir.' },
  { ad: 'Sardes Antik Kenti', il: 'Manisa', ilce: 'Salihli', latitude: 38.4878, longitude: 28.0397, bilgi: 'Lidya Krallığı\'nın başkenti olan ve paranın ilk basıldığı yer olarak bilinen tarihi kent.' },
  { ad: 'Aizanoi Antik Kenti', il: 'Kütahya', ilce: 'Çavdarhisar', latitude: 39.2053, longitude: 29.6106, bilgi: 'Anadolu\'daki en iyi korunmuş Zeus Tapınağı\'na ev sahipliği yapan, "İkinci Efes" olarak anılan antik kent.' },
  { ad: 'Sagalassos Antik Kenti', il: 'Burdur', ilce: 'Ağlasun', latitude: 37.6775, longitude: 30.5203, bilgi: 'Torosların güney yamacında yer alan, Antoninler Çeşmesi gibi görkemli yapılarıyla etkileyici bir Roma kenti.' },
  { ad: 'Xanthos-Letoon Antik Kentleri', il: 'Antalya', ilce: 'Kaş', latitude: 36.3569, longitude: 29.3194, bilgi: 'Likya medeniyetinin idari ve dini merkezi olan, anıt mezarları ve yazıtları ile önemli ikiz arkeolojik alanlar.' },
  { ad: 'Çifte Minareli Medrese', il: 'Erzurum', ilce: 'Yakutiye', latitude: 39.9056, longitude: 41.2758, bilgi: 'Selçuklu mimarisinin en görkemli örneklerinden, Anadolu\'nun en büyük medresesi.' },
  { ad: 'İznik Ayasofyası', il: 'Bursa', ilce: 'İznik', latitude: 40.4292, longitude: 29.7208, bilgi: 'Hristiyanlık için önemli konsillerin toplandığı, daha sonra camiye çevrilen tarihi yapı.' },
  { ad: 'Sultanhanı Kervansarayı', il: 'Aksaray', ilce: 'Sultanhanı', latitude: 38.2472, longitude: 33.5458, bilgi: 'Anadolu Selçuklu döneminden kalma, İpek Yolu üzerindeki en büyük ve en görkemli kervansaray.' },
  { ad: 'Kariye Müzesi (Chora Kilisesi)', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0311, longitude: 28.9392, bilgi: 'Dünyanın en iyi korunmuş Bizans mozaik ve fresklerine ev sahipliği yapan, sanat tarihi açısından paha biçilmez bir yapı.' },
  { ad: 'Eyüp Sultan Camii', il: 'İstanbul', ilce: 'Eyüpsultan', latitude: 41.0475, longitude: 28.9333, bilgi: 'İslam peygamberi Muhammed\'in sancaktarı Ebu Eyyûb el-Ensârî\'nin kabrine ev sahipliği yapan, İstanbul\'un en kutsal mekanlarından biri.' },
  { ad: 'Mısır Çarşısı', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0164, longitude: 28.9711, bilgi: 'Tarihi baharat ve bitki dükkanlarıyla ünlü, canlı ve otantik atmosferiyle ziyaretçileri çeken kapalı çarşı.' },
  { ad: 'Beylerbeyi Sarayı', il: 'İstanbul', ilce: 'Üsküdar', latitude: 41.0433, longitude: 29.0408, bilgi: 'Boğaziçi\'nin Anadolu yakasında, Sultan Abdülaziz tarafından yazlık saray olarak inşa ettirilen zarif yapı.' },
  { ad: 'Anadolu Hisarı', il: 'İstanbul', ilce: 'Beykoz', latitude: 41.0825, longitude: 29.0664, bilgi: 'Yıldırım Bayezid tarafından Rumeli Hisarı\'ndan önce inşa edilen, Boğaz\'ın en dar noktasındaki tarihi kale.' },
  { ad: 'Fener Rum Patrikhanesi ve Aya Yorgi Kilisesi', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0286, longitude: 28.9519, bilgi: 'Ortodoks dünyasının ruhani merkezi olan, önemli ikonalar ve kutsal emanetler barındıran tarihi kompleks.' },
  { ad: 'Afrodisias Antik Kenti', il: 'Aydın', ilce: 'Karacasu', latitude: 37.7094, longitude: 28.7236, bilgi: 'Aşk ve güzellik tanrıçası Afrodit\'e adanmış, stadyumu ve heykeltıraşlık okuluyla ünlü UNESCO Dünya Mirası.' },
  { ad: 'Milet Antik Kenti', il: 'Aydın', ilce: 'Didim', latitude: 37.5303, longitude: 27.2775, bilgi: 'Felsefenin ve pozitif bilimlerin doğduğu yer olarak kabul edilen, tiyatrosu ve Faustina Hamamı ile önemli bir İyon kenti.' },
  { ad: 'Kaunos Antik Kenti ve Kral Mezarları', il: 'Muğla', ilce: 'Dalyan', latitude: 36.8239, longitude: 28.6219, bilgi: 'Dalyan Nehri\'nin karşısında, kayalara oyulmuş görkemli tapınak tipi mezarlarıyla ünlü antik liman kenti.' },
  { ad: 'Perge Antik Kenti', il: 'Antalya', ilce: 'Aksu', latitude: 36.9589, longitude: 30.8531, bilgi: 'Sütunlu caddesi, anıtsal kapıları ve stadyumu ile Roma döneminin en düzenli şehirlerinden biri.' },
  { ad: 'Myra Antik Kenti ve St. Nicholas Kilisesi', il: 'Antalya', ilce: 'Demre', latitude: 36.2586, longitude: 29.9856, bilgi: 'Likya dönemi kaya mezarları ve Noel Baba olarak bilinen Aziz Nikolaos\'un piskoposluk yaptığı kilise ile ünlü.' },
  { ad: 'Patara Antik Kenti', il: 'Antalya', ilce: 'Kaş', latitude: 36.2603, longitude: 29.3142, bilgi: 'Likya Birliği\'nin başkenti, antik feneri ve meclis binası ile demokrasi tarihinde önemli bir yere sahip.' },
  { ad: 'Mamure Kalesi', il: 'Mersin', ilce: 'Anamur', latitude: 36.0803, longitude: 32.8953, bilgi: 'Akdeniz kıyısındaki en iyi korunmuş kalelerden biri, Roma, Bizans ve Selçuklu izlerini taşır.' },
  { ad: 'Çatalhöyük Neolitik Kenti', il: 'Konya', ilce: 'Çumra', latitude: 37.6675, longitude: 32.8283, bilgi: '9000 yıllık geçmişiyle insanlığın ilk yerleşim yerlerinden ve şehir hayatına geçişin en önemli kanıtlarından biri.' },
  { ad: 'Gök Medrese', il: 'Sivas', ilce: 'Sivas Merkez', latitude: 39.7500, longitude: 37.0167, bilgi: 'Anadolu Selçuklu mimarisinin en zarif örneklerinden, firuze renkli çinileriyle göz alıcı bir yapı.' },
  { ad: 'Alacahöyük', il: 'Çorum', ilce: 'Alaca', latitude: 40.2361, longitude: 34.6944, bilgi: 'Hititlerin önemli bir kült merkezi, sfenksli kapısı ve kral mezarlarından çıkan altın eserlerle tanınır.' },
  { ad: 'Midas Anıtı (Yazılıkaya)', il: 'Eskişehir', ilce: 'Han', latitude: 39.2997, longitude: 30.8208, bilgi: 'Frigya Vadisi\'nde yer alan, Friglerin efsanevi kralı Midas\'a adandığı düşünülen devasa kaya anıtı.' },
  { ad: 'Akdamar Adası ve Kutsal Haç Kilisesi', il: 'Van', ilce: 'Gevaş', latitude: 38.3375, longitude: 43.0375, bilgi: 'Van Gölü içinde yer alan ada ve üzerindeki, dış cephe kabartmalarıyla bir sanat harikası olan Ermeni kilisesi.' },
  { ad: 'Balıklıgöl (Halil-ür Rahman Gölü)', il: 'Şanlıurfa', ilce: 'Eyyübiye', latitude: 37.1475, longitude: 38.7881, bilgi: 'İbrahim peygamberin ateşe atıldığında düştüğü yer olduğuna inanılan, kutsal balıklarıyla ünlü manevi bir mekan.' },
  { ad: 'On Gözlü Köprü', il: 'Diyarbakır', ilce: 'Sur', latitude: 37.8825, longitude: 40.2331, bilgi: 'Dicle Nehri üzerinde, on kemerli yapısıyla şehrin simgelerinden biri haline gelmiş tarihi köprü.' },
  { ad: 'Hoşap Kalesi', il: 'Van', ilce: 'Gürpınar', latitude: 38.3183, longitude: 43.6669, bilgi: 'Sarp bir kaya kütlesi üzerine kurulmuş, görkemli girişi ve içindeki yapılarıyla Orta Çağ kale mimarisinin etkileyici bir örneği.' },
  { ad: 'Trabzon Ayasofyası', il: 'Trabzon', ilce: 'Ortahisar', latitude: 41.0036, longitude: 39.6958, bilgi: 'Geç Bizans döneminin en güzel örneklerinden, freskleri ve denize nazır konumuyla dikkat çeken tarihi kilise/cami.' },
  { ad: 'Zilkale', il: 'Rize', ilce: 'Çamlıhemşin', latitude: 40.8653, longitude: 41.0261, bilgi: 'Fırtına Vadisi\'ne hakim bir noktada, sarp bir yamaç üzerine kurulmuş, masalsı görünüme sahip Orta Çağ kalesi.' },
  { ad: 'Laodikeia Antik Kenti', il: 'Denizli', ilce: 'Pamukkale', latitude: 37.8447, longitude: 29.1000, bilgi: 'Antik Frigya bölgesinin zengin şehirlerinden biri, antik tiyatrosu ve su sistemleriyle dikkat çeker.' },
  { ad: 'Tarsus Ulu Camii', il: 'Mersin', ilce: 'Tarsus', latitude: 36.9175, longitude: 34.8917, bilgi: 'Eski bir kilisenin yerine inşa edilen bu cami, Selçuklu ve Memlük etkilerini taşır.' },
  { ad: 'İnce Minareli Medrese', il: 'Konya', ilce: 'Selçuklu', latitude: 37.8711, longitude: 32.4936, bilgi: 'Selçuklu taş işçiliğinin zirvesini temsil eden, 13. yüzyıla ait bir medrese.' },
  { ad: 'Çorum Saat Kulesi', il: 'Çorum', ilce: 'Çorum Merkez', latitude: 40.5481, longitude: 34.9539, bilgi: '1896 yılında yaptırılan, şehrin simgesi haline gelmiş tarihi saat kulesi.' },
  { ad: 'Alahan Manastırı', il: 'Mersin', ilce: 'Mut', latitude: 36.6533, longitude: 33.3281, bilgi: '5. yüzyıla tarihlenen, dağ yamacına kurulmuş erken dönem Hristiyan yapılarından biri.' },
  { ad: 'Arslantepe Höyüğü', il: 'Malatya', ilce: 'Battalgazi', latitude: 38.3558, longitude: 38.3161, bilgi: 'UNESCO Dünya Mirası listesine giren, ilk saray kompleksi ve kılıç kullanımının izlerini barındıran höyük.' },
  { ad: 'Kadirli Ala Cami', il: 'Osmaniye', ilce: 'Kadirli', latitude: 37.3703, longitude: 36.0953, bilgi: 'Roma döneminden kalan bir bazilikanın üzerine inşa edilmiş cami, mimari açıdan ilginç bir sentez sunar.' },
  { ad: 'Beçin Kalesi', il: 'Muğla', ilce: 'Milas', latitude: 37.3053, longitude: 27.7839, bilgi: 'Menteşe Beyliği\'ne başkentlik yapmış, surları ve iç kale yapılarıyla dikkat çeken tarihi alan.' },
  { ad: 'Boğazkale Yazılıkaya Açıkhava Tapınağı', il: 'Çorum', ilce: 'Boğazkale', latitude: 40.0186, longitude: 34.6197, bilgi: 'Hitit tanrılarının kabartmalarıyla ünlü kutsal kaya tapınağı, Hattuşa\'nın önemli bir parçası.' },
  { ad: 'İstanbul Arkeoloji Müzesi', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0125, longitude: 28.9831, bilgi: 'Dünyanın en büyük müzeleri arasında yer alan, antik eser koleksiyonu açısından zengin bir müze.' },
  { ad: 'Zeyrek Camii (Pantokrator Manastırı)', il: 'İstanbul', ilce: 'Fatih', latitude: 41.0194, longitude: 28.9639, bilgi: 'Bizans dönemine ait en büyük dini yapılardan biri, Osmanlı döneminde camiye çevrilmiştir.' },

  { ad: 'Anıtkabir', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9250, longitude: 32.8369, bilgi: 'Türkiye Cumhuriyeti\'nin kurucusu Mustafa Kemal Atatürk\'ün anıt mezarının bulunduğu, ulusal bir sembol.' },
  { ad: 'Ankara Kalesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9419, longitude: 32.8661, bilgi: 'Şehre hakim bir tepe üzerinde yer alan, tarihi dokusunu koruyan ve eski Ankara evleriyle çevrili kale.' },
  { ad: 'Kocatepe Camii', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9167, longitude: 32.8597, bilgi: 'Ankara\'nın en büyük camisi, klasik Osmanlı mimarisi tarzında inşa edilmiş modern bir başyapıt.' },
  { ad: 'Hacı Bayram Veli Camii', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9444, longitude: 32.8594, bilgi: 'Ankara\'nın manevi kalbi olan, Augustus Tapınağı\'nın bitişiğinde yer alan ve Hacı Bayram Veli\'nin türbesine ev sahipliği yapan tarihi cami.' },
  { ad: 'Ulucanlar Cezaevi Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9369, longitude: 32.8711, bilgi: 'Türkiye\'nin yakın siyasi tarihine tanıklık etmiş, birçok yazar ve siyasetçinin kaldığı, restore edilerek müzeye çevrilmiş etkileyici bir yapı.' },
  { ad: 'MTA Şehit Cuma Dağ Tabiat Tarihi Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9056, longitude: 32.8125, bilgi: 'Türkiye\'nin ve dünyanın dört bir yanından fosiller, mineraller ve göktaşları gibi jeolojik ve paleontolojik örneklerin sergilendiği müze.' },
  { ad: 'Etnografya Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9339, longitude: 32.8525, bilgi: 'Türk sanatının Selçuklu devrinden günümüze kadar olan örneklerinin sergilendiği, Atatürk\'ün naaşının Anıtkabir\'e nakledilmeden önce geçici olarak ağırlandığı yer.' },
  { ad: 'Duatepe Anıtı', il: 'Ankara', ilce: 'Polatlı', latitude: 39.5858, longitude: 32.2575, bilgi: 'Sakarya Meydan Muharebesi\'nde stratejik öneme sahip olan Duatepe\'nin geri alınması anısına yapılan anıt.' },
  { ad: 'Cumhuriyet Müzesi (II. TBMM Binası)', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9411, longitude: 32.8553, bilgi: '1924-1960 yılları arasında Türkiye Büyük Millet Meclisi olarak hizmet veren, Cumhuriyetin ilk yıllarına tanıklık eden tarihi bina.' },
  { ad: 'Gordion Antik Kenti', il: 'Ankara', ilce: 'Polatlı', latitude: 39.6542, longitude: 31.9939, bilgi: 'Frigya\'nın başkenti olan, efsanevi Kral Midas\'ın yaşadığı ve Büyük İskender\'in "Gordion Düğümü"nü kestiği yer olarak bilinen antik kent.' },
  { ad: 'Ankara Resim ve Heykel Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9333, longitude: 32.8519, bilgi: 'Tarihi Türk Ocağı binasında hizmet veren, 19. yüzyıldan günümüze Türk sanatının en önemli eserlerini barındıran müze.' },
  { ad: 'Arslanhane (Ahi Şerafettin) Camii', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9381, longitude: 32.8633, bilgi: '13. yüzyıl Selçuklu mimarisinin en güzel örneklerinden, ahşap direkleri ve antik sütun başlıklarıyla "ahşap direkli camiler" arasında özel bir yere sahip.' },
  { ad: 'Cenabi Ahmet Paşa Camii', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9344, longitude: 32.8711, bilgi: 'Mimar Sinan tarafından tasarlanan, klasik Osmanlı mimarisinin Ankara\'daki önemli örneklerinden biri olan cami.' },
  { ad: 'Hamamönü Evleri', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9317, longitude: 32.8647, bilgi: '19. yüzyıl sivil mimari örneklerinin restore edildiği, tarihi sokakları, konakları ve sanat atölyeleriyle Ankara\'nın kültürel merkezi.' },
  { ad: 'Somut Olmayan Kültürel Miras Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9311, longitude: 32.8642, bilgi: 'Hamamönü\'nde yer alan, Karagöz-Hacivat, meddahlık gibi geleneksel Türk sanatlarının yaşatıldığı ve sergilendiği müze.' },
  { ad: 'Mogan Parkı', il: 'Ankara', ilce: 'Gölbaşı', latitude: 39.7892, longitude: 32.7844, bilgi: 'Mogan Gölü kıyısında yer alan, geniş yeşil alanları, yürüyüş yolları ve sosyal tesisleriyle Ankara\'nın en büyük rekreasyon alanlarından biri.' },
  { ad: 'Sakarya Şehitleri ve Zafer Anıtı', il: 'Ankara', ilce: 'Polatlı', latitude: 39.6517, longitude: 32.1644, bilgi: 'Sakarya Meydan Muharebesi\'nde şehit düşen askerlerin anısına, savaşın en çetin geçtiği noktalardan birine inşa edilen anıt.' },
  { ad: 'Ulus Cumhuriyet Anıtı', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9425, longitude: 32.8561, bilgi: 'Ulus Meydanı\'nda yer alan, İtalyan heykeltıraş Pietro Canonica tarafından yapılan ve Atatürk\'ü mareşal üniformasıyla tasvir eden anıt.' },
  { ad: 'Taceddin Sultan Camii ve Dergahı', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9319, longitude: 32.8656, bilgi: 'İstiklal Marşı şairi Mehmet Akif Ersoy\'un bir süre yaşadığı ve marşı yazdığı, manevi öneme sahip tarihi mekan.' },
  { ad: 'Kurtuluş Savaşı Müzesi (I. TBMM Binası)', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9422, longitude: 32.8550, bilgi: 'Milli Mücadele\'nin yönetildiği ve Türkiye Cumhuriyeti\'nin temellerinin atıldığı, I. Ulusal Mimarlık Akımı\'nın en önemli yapısı.' },
  { ad: 'Beypazarı Yaşayan Müze', il: 'Ankara', ilce: 'Beypazarı', latitude: 39.9336, longitude: 31.9169, bilgi: 'Tarihi bir konakta, Türk gelenek ve göreneklerinin ziyaretçilerin katılımıyla canlandırıldığı interaktif bir müze.' },
  { ad: 'Elmadağ Kayak Merkezi', il: 'Ankara', ilce: 'Elmadağ', latitude: 39.8667, longitude: 32.9833, bilgi: 'Ankara\'ya en yakın konumda bulunan, kış sporları ve kayak için popüler bir merkez.' },
  { ad: 'Türk Hava Kurumu Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9481, longitude: 32.8519, bilgi: 'Türkiye\'nin havacılık tarihine ışık tutan, uçak modelleri, belgeler ve fotoğrafların sergilendiği müze.' },
  { ad: 'Gordion Müzesi', il: 'Ankara', ilce: 'Polatlı', latitude: 39.6528, longitude: 31.9950, bilgi: 'Gordion Antik Kenti kazılarında çıkarılan Frig dönemine ait eserlerin sergilendiği arkeoloji müzesi.' },
  { ad: 'Rahmi M. Koç Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9408, longitude: 32.8631, bilgi: 'Tarihi Çengelhan\'da yer alan, sanayi, ulaşım ve iletişim tarihine adanmış zengin bir koleksiyona sahip sanayi müzesi.' },
  { ad: 'Alagöz Karargah Müzesi', il: 'Ankara', ilce: 'Polatlı', latitude: 39.6894, longitude: 32.4942, bilgi: 'Sakarya Meydan Muharebesi sırasında Batı Cephesi Komutanlığı\'nın karargah olarak kullandığı, Atatürk\'ün anılarını barındıran ev.' },
  { ad: 'Hava Kuvvetleri Müzesi', il: 'Ankara', ilce: 'Keçiören', latitude: 39.9667, longitude: 32.7833, bilgi: 'Türk Hava Kuvvetleri\'nin tarihini ve gelişimini sergileyen, çeşitli uçakların bulunduğu askeri müze.' },
  { ad: 'Ankara Üniversitesi Oyuncak Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9328, longitude: 32.8336, bilgi: 'Türkiye\'nin ilk oyuncak müzesi olup, geleneksel ve modern oyuncaklardan oluşan zengin bir koleksiyona ev sahipliği yapar.' },
  { ad: 'Devlet Mezarlığı Müzesi', il: 'Ankara', ilce: 'Yenimahalle', latitude: 39.9467, longitude: 32.7564, bilgi: 'Cumhurbaşkanları ve Kurtuluş Savaşı komutanlarının mezarlarının bulunduğu alandaki, bu kişilere ait eşyaların sergilendiği müze.' },
  { ad: 'Cumhurbaşkanlığı Atatürk Müze Köşk', il: 'Ankara', ilce: 'Çankaya', latitude: 39.8931, longitude: 32.8614, bilgi: 'Atatürk\'ün 1921-1932 yılları arasında ikamet ettiği, Cumhuriyetin ilk yıllarına tanıklık eden ve orijinal eşyalarıyla korunan köşk.' },
  { ad: 'Cin Ali Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9058, longitude: 32.8522, bilgi: 'Türkiye\'de nesillerin okuma yazmayı öğrendiği Cin Ali karakterine adanmış, nostaljik ve eğitici bir müze.' },
  { ad: 'İş Bankası İktisadi Bağımsızlık Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9419, longitude: 32.8567, bilgi: 'Tarihi İş Bankası Genel Müdürlük binasında, Cumhuriyetin iktisadi tarihini ve bankacılığın gelişimini anlatan müze.' },
  { ad: 'Mehmet Akif Ersoy Edebiyat Müze Kütüphanesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9322, longitude: 32.8653, bilgi: 'Taceddin Dergahı kompleksi içinde, Mehmet Akif Ersoy ve diğer önemli edebiyatçıların eserlerinin bulunduğu kütüphane ve müze.' },
  { ad: 'Ankara Vakıf Eserleri Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9397, longitude: 32.8572, bilgi: 'Vakıflar Genel Müdürlüğü\'ne ait halı, kilim, ahşap, maden ve hat sanatı gibi eserlerin sergilendiği tarihi bir yapı.' },
  { ad: 'Türk Telekom Telekomünikasyon Müzesi', il: 'Ankara', ilce: 'Aydınlıkevler', latitude: 39.9542, longitude: 32.8714, bilgi: 'Türkiye\'nin telekomünikasyon tarihini, ilk telefonlardan günümüz teknolojisine kadar anlatan müze.' },
  { ad: 'Hatti Anıtı', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9304, longitude: 32.8564, bilgi: 'Sıhhiye Meydanı\'nda yer alan, Hitit medeniyetinin sembolü olan Güneş Kursu\'nun büyütülmüş bir kopyasıdır.' },
  { ad: 'Topçu ve Füze Okulu Sınıf Müzesi', il: 'Ankara', ilce: 'Polatlı', latitude: 39.5694, longitude: 32.1389, bilgi: 'Türk topçuluk tarihini ve gelişimini sergileyen, çeşitli top ve füzelerin bulunduğu askeri bir müze.' },
  { ad: 'TCDD Malıköy Tren İstasyonu Müzesi', il: 'Ankara', ilce: 'Polatlı', latitude: 39.7569, longitude: 32.5028, bilgi: 'Sakarya Meydan Muharebesi sırasında lojistik üs olarak kullanılan tarihi tren istasyonunun restore edilmesiyle oluşturulan açık hava müzesi.' },
  { ad: 'Roma Hamamı', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9469, longitude: 32.8553, bilgi: 'MS 3. yüzyılda inşa edilmiş, palaestra (spor alanı), frigidarium (soğukluk) ve caldarium (sıcaklık) bölümleriyle büyük bir Roma hamamı kompleksi.' },
  { ad: 'Atatürk Orman Çiftliği', il: 'Ankara', ilce: 'Yenimahalle', latitude: 39.9486, longitude: 32.7931, bilgi: 'Atatürk tarafından kurulan, içerisinde hayvanat bahçesi, müzeler, tarım alanları ve rekreasyon bölgeleri barındıran geniş bir arazi.' },
  { ad: '75. Yıl Cumhuriyet Eğitim Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9133, longitude: 32.8503, bilgi: 'Cumhuriyet dönemi eğitim tarihini, eski derslik canlandırmaları ve materyallerle anlatan bir müze.' },
  { ad: 'Botanik Parkı', il: 'Ankara', ilce: 'Çankaya', latitude: 39.8939, longitude: 32.8569, bilgi: 'Atakule\'nin yanında yer alan, farklı bitki türlerini barındıran, peyzaj düzenlemesiyle dikkat çeken bir şehir parkı.' },
  { ad: 'Zincirli Cami', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9431, longitude: 32.8592, bilgi: '17. yüzyılda inşa edilmiş, minaresindeki zincir detayıyla bilinen, Ulus\'taki tarihi camilerden biridir.' },
  { ad: 'Sultan Alaeddin Camii', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9417, longitude: 32.8622, bilgi: 'Ankara Kalesi içinde yer alan, şehrin en eski camilerinden biri olan Selçuklu dönemi yapısı.' },
  { ad: 'Beypazarı Türk Hamam Müzesi', il: 'Ankara', ilce: 'Beypazarı', latitude: 39.9333, longitude: 31.9167, bilgi: 'Tarihi bir hamamın restore edilmesiyle, geleneksel Türk hamam kültürünü ve objelerini sergileyen özgün bir müze.' },
  { ad: 'Atatürk Orman Çiftliği Müze ve Sergi Salonu', il: 'Ankara', ilce: 'Yenimahalle', latitude: 39.9483, longitude: 32.7928, bilgi: 'AOÇ\'nin kuruluşunu ve Atatürk\'ün tarıma verdiği önemi anlatan, tarihi bira fabrikası binasında yer alan müze.' },
  { ad: 'PTT Pul Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9403, longitude: 32.8556, bilgi: 'Osmanlı\'dan günümüze posta pullarının ve iletişim tarihinin sergilendiği, mimari açıdan da değerli bir binada hizmet veren müze.' },
  { ad: 'MKE Sanayi ve Teknoloji Müzesi', il: 'Ankara', ilce: 'Yenimahalle', latitude: 39.9419, longitude: 32.7969, bilgi: 'Türkiye\'nin savunma sanayii tarihini ve Makine ve Kimya Enstitüsü\'nün üretimlerini sergileyen bir müze.' },
  { ad: 'Atatürk Konutu ve Demiryolları Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9367, longitude: 32.8436, bilgi: 'Ankara Garı kompleksi içinde, Atatürk\'ün Milli Mücadele yıllarında ilk konutu olarak kullandığı ve demiryolları tarihinin sergilendiği yapı.' },
  { ad: 'Kesikbaş Türbesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9414, longitude: 32.8614, bilgi: 'Ankara Kalesi yakınlarında bulunan, halk arasında çeşitli efsanelere konu olmuş manevi bir ziyaret noktası.' },
  { ad: 'Ziraat Bankası Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9431, longitude: 32.8569, bilgi: 'Tarihi Ziraat Bankası Genel Müdürlük binasında, Türkiye\'nin tarım ve bankacılık tarihine ışık tutan müze.' },
  { ad: 'Ahi Elvan Camii', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9400, longitude: 32.8614, bilgi: '14. yüzyılda inşa edilmiş, ahşap tavanı ve sade mimarisiyle dikkat çeken, Samanpazarı\'ndaki tarihi camilerden biri.' },
  { ad: 'Mehmetçik Anıtı', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9258, longitude: 32.8358, bilgi: 'Anıtkabir\'e çıkan yolun başında, Türk askerini temsil eden ve Kurtuluş Savaşı\'nı simgeleyen anıt.' },
  { ad: 'Gökyay Vakfı Satranç Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9308, longitude: 32.8633, bilgi: 'Farklı ülkelerden ve temalardan oluşan geniş bir satranç takımı koleksiyonuna sahip, alanında özgün bir müze.' },
  { ad: 'Yörük Köyü (Beypazarı)', il: 'Ankara', ilce: 'Beypazarı', latitude: 40.1667, longitude: 31.9167, bilgi: 'Beypazarı\'nda geleneksel Türkmen-Yörük kültürünün yaşatıldığı, otantik evleri ve yaşam tarzıyla bir açık hava müzesi.' },
  { ad: 'Beypazarı Kent Tarihi Müzesi', il: 'Ankara', ilce: 'Beypazarı', latitude: 40.1692, longitude: 31.9219, bilgi: 'Tarihi bir okul binasında, Beypazarı\'nın sosyal, kültürel ve ekonomik tarihini sergileyen bir müze.' },
  { ad: 'Göksu Parkı', il: 'Ankara', ilce: 'Etimesgut', latitude: 39.9856, longitude: 32.6739, bilgi: 'Geniş bir gölet etrafında kurulu, su sporları, yürüyüş alanları ve sosyal tesisleriyle popüler bir rekreasyon alanı.' },
  { ad: 'Karyağdı Türbesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9500, longitude: 32.8539, bilgi: 'Halk arasında kışın ortasında kar yağdırdığına inanılan bir evliyanın yattığı, ilginç bir hikayesi olan türbe.' },
  { ad: 'Beypazarı Yaşayan Köy', il: 'Ankara', ilce: 'Beypazarı', latitude: 40.1650, longitude: 31.9200, bilgi: 'Geleneksel Anadolu köy hayatının canlandırıldığı, atölyeler ve etkinliklerle ziyaretçilere interaktif bir deneyim sunan bir açık hava müzesi.' },
  { ad: 'Zafer Anıtı', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9425, longitude: 32.8561, bilgi: 'Ulus Meydanı\'nda yer alan, Kurtuluş Savaşı\'nı ve Türk Ordusu\'nun zaferini simgeleyen, Atatürk\'ü at üzerinde tasvir eden anıt.' },
  { ad: 'Çubuk Barajı', il: 'Ankara', ilce: 'Çubuk', latitude: 40.1167, longitude: 32.9667, bilgi: 'Cumhuriyet döneminin ilk barajı olan, çevresindeki rekreasyon alanları ve Atatürk Köşkü ile tarihi bir öneme sahip.' },
  { ad: 'Milli Savunma Bakanlığı Arşiv Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9144, longitude: 32.8583, bilgi: 'Türk askeri tarihine ait önemli belgelerin, haritaların ve fotoğrafların sergilendiği bir arşiv ve müze.' },
  { ad: 'Karacabey Camii', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9347, longitude: 32.8681, bilgi: '15. yüzyılda inşa edilmiş, ters T planlı mimarisiyle (zaviyeli cami) dikkat çeken, Hamamönü yakınlarındaki tarihi yapı.' },
  { ad: 'Meteoroloji Müzesi', il: 'Ankara', ilce: 'Keçiören', latitude: 39.9833, longitude: 32.8500, bilgi: 'Türkiye\'nin meteoroloji tarihini, kullanılan eski aletleri ve yapılan çalışmaları sergileyen ilginç bir müze.' },
  { ad: 'Ayaş Evleri', il: 'Ankara', ilce: 'Ayaş', latitude: 40.0167, longitude: 32.3333, bilgi: 'Tarihi İpek Yolu üzerinde yer alan Ayaş\'ın, geleneksel Osmanlı sivil mimarisinin özelliklerini taşıyan tarihi konakları.' },
  { ad: 'Jandarma Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.8975, longitude: 32.8053, bilgi: 'Jandarma Teşkilatı\'nın kuruluşundan günümüze tarihini, kıyafetlerini ve ekipmanlarını sergileyen askeri müze.' },
  { ad: 'Mimar Sinan Anıtı', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9328, longitude: 32.8467, bilgi: 'DTCF Fakültesi önünde yer alan, büyük usta Mimar Sinan\'ı onurlandırmak için yapılmış bir anıt.' },
  { ad: 'Nallıhan Kuş Cenneti', il: 'Ankara', ilce: 'Nallıhan', latitude: 40.1667, longitude: 31.4333, bilgi: 'Sarıyar Baraj Gölü kıyısında, yüzlerce kuş türüne ev sahipliği yapan, fotoğrafçılık ve doğa gözlemi için önemli bir sulak alan.' },
  { ad: 'Tabakhane Camii', il: 'Ankara', ilce: 'Ayaş', latitude: 40.0194, longitude: 32.3308, bilgi: 'Ayaş ilçesinde bulunan, Selçuklu ve Osmanlı mimari özelliklerini bir arada barındıran tarihi bir cami.' },
  { ad: 'Şefik Bursalı Müze Evi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9231, longitude: 32.8633, bilgi: 'Ünlü ressam Şefik Bursalı\'nın yaşamış olduğu ve eserlerinin sergilendiği, müzeye dönüştürülmüş evi.' },
  { ad: 'İbadullah Camii', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9042, longitude: 32.8533, bilgi: 'Kavaklıdere\'de bulunan, modern mimari ile geleneksel unsurları birleştiren, estetik bir tasarıma sahip cami.' },
  { ad: 'Mustafa Ayaz Vakfı Plastik Sanatlar Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9056, longitude: 32.8028, bilgi: 'Ressam Mustafa Ayaz\'ın eserlerinin yanı sıra diğer sanatçıların da eserlerinin sergilendiği özel bir modern sanat müzesi.' },
  { ad: 'Beypazarı Tarih ve Kültür Müzesi', il: 'Ankara', ilce: 'Beypazarı', latitude: 40.1683, longitude: 31.9214, bilgi: 'Tarihi bir konakta, Beypazarı\'nın zengin tarihini, el sanatlarını ve günlük yaşam kültürünü yansıtan eserlerin sergilendiği müze.' },
  { ad: 'ODTÜ Arkeoloji Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.8953, longitude: 32.7797, bilgi: 'ODTÜ kampüsü içinde, üniversitenin yaptığı kazılardan elde edilen arkeolojik buluntuların sergilendiği bilimsel bir müze.' },
  { ad: 'Ankara Üniversitesi Ziraat Fakültesi Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9575, longitude: 32.8761, bilgi: 'Türkiye\'nin tarım tarihini, kullanılan aletleri ve tarımsal gelişmeleri sergileyen, alanında öncü bir müze.' },
  { ad: 'Ahi Şerafettin Türbesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9381, longitude: 32.8633, bilgi: 'Arslanhane Camii\'nin bitişiğinde yer alan, 13. yüzyıl Ahi lideri Ahi Şerafettin\'e ait türbe.' },
  { ad: 'Keçiören Estergon Kalesi Türk Kültür Merkezi', il: 'Ankara', ilce: 'Keçiören', latitude: 39.9881, longitude: 32.8633, bilgi: 'Macaristan\'daki Estergon Kalesi\'nin bir replikası olarak inşa edilmiş, içinde Etnografya Müzesi bulunan bir kültür merkezi.' },
  { ad: 'Hacettepe Camii', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9350, longitude: 32.8625, bilgi: 'Samanpazarı\'nda yer alan, 15. yüzyıldan kalma, sade ve zarif mimarisiyle dikkat çeken tarihi bir cami.' },
  { ad: 'Haritacılık Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9239, longitude: 32.8894, bilgi: 'Harita Genel Komutanlığı bünyesinde, Osmanlı\'dan günümüze haritacılık tarihini ve teknolojisini sergileyen özel bir müze.' },
  { ad: 'Ankara Olgunlaşma Enstitüsü 100. Yıl Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9367, longitude: 32.8550, bilgi: 'Geleneksel Türk el sanatlarının ve kıyafetlerinin en güzel örneklerinin sergilendiği, enstitünün tarihi binasındaki müze.' },
  { ad: 'Ağaçayak Camii', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9397, longitude: 32.8606, bilgi: '18. yüzyılda inşa edilmiş, adını ahşap ayaklar üzerine kurulu olmasından alan, Ulus\'taki ilginç mimariye sahip camilerden biri.' },
  { ad: 'Türkiye Barolar Birliği Hukuk Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9078, longitude: 32.8164, bilgi: 'Türkiye\'nin hukuk tarihine dair belgelerin, cübbelerin ve önemli dava dosyalarının sergilendiği müze.' },
  { ad: 'Eskicioğlu Camii', il: 'Ankara', ilce: 'Ayaş', latitude: 40.0189, longitude: 32.3322, bilgi: 'Ayaş ilçe merkezinde yer alan, ahşap işçiliği ve kalem işi süslemeleriyle dikkat çeken tarihi bir cami.' },
  { ad: 'Yayıncılık Tarihi Müzesi', il: 'Ankara', ilce: 'Yenimahalle', latitude: 39.9603, longitude: 32.8058, bilgi: 'Türkiye Gazeteciler Cemiyeti tarafından kurulan, matbaa makineleri ve yayıncılık tarihine ait objelerin bulunduğu müze.' },
  { ad: 'Çubuk Şehir Müzesi', il: 'Ankara', ilce: 'Çubuk', latitude: 40.2369, longitude: 33.0319, bilgi: 'Çubuk ilçesinin sosyal ve kültürel tarihini yansıtan objelerin ve belgelerin sergilendiği bir kent müzesi.' },
  { ad: 'Toprak Mahsulleri Ofisi Müzesi', il: 'Ankara', ilce: 'Yenimahalle', latitude: 39.9392, longitude: 32.8106, bilgi: 'TMO\'nun tarihi silolarında, Türkiye\'nin tarım ve hububat tarihini anlatan "Ekmek Müzesi" olarak da bilinen yer.' },
  { ad: 'Hacı Arap Camii', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9383, longitude: 32.8600, bilgi: 'Samanpazarı\'nda bulunan, küçük boyutlu ve sade mimariye sahip, 15. yüzyıldan kalma tarihi bir cami.' },
  { ad: 'Ahi Yakup Camii', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9408, longitude: 32.8603, bilgi: '14. yüzyılda inşa edilmiş, Ahi liderlerinden Ahi Yakup\'a adanmış, ahşap tavanlı ve sakin bir atmosfere sahip cami.' },
  { ad: 'Anadolu Mimarlık ve Mobilya Kültürel Miras Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9406, longitude: 32.8639, bilgi: 'Ankara Kalesi\'nde, geleneksel Anadolu sivil mimarisi ve mobilya sanatının örneklerinin sergilendiği özel bir müze.' },
  { ad: 'Prof. Dr. Ülker Muncuk Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9328, longitude: 32.8469, bilgi: 'Hacettepe Üniversitesi bünyesinde, geleneksel Türk el sanatları, takılar ve giysilerden oluşan zengin bir koleksiyonu barındıran müze.' },
  { ad: 'Türkiye Eğitim Derneği Ankara Koleji Okul Müzesi', il: 'Ankara', ilce: 'Gölbaşı', latitude: 39.8406, longitude: 32.7831, bilgi: 'TED Ankara Koleji\'nin tarihini, eğitim materyallerini ve ünlü mezunlarına ait anıları sergileyen okul müzesi.' },
  { ad: 'Sebahattin Yıldız Müzesi', il: 'Ankara', ilce: 'Gölbaşı', latitude: 39.8250, longitude: 32.8000, bilgi: 'İş adamı Sebahattin Yıldız\'ın kişisel koleksiyonlarından oluşan, klasik otomobiller, antika objeler gibi geniş bir yelpazeyi sunan özel müze.' },
  { ad: 'Erimtan Arkeoloji ve Sanat Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9411, longitude: 32.8647, bilgi: 'Ankara Kalesi\'nin girişinde, Yüksel Erimtan koleksiyonuna ait Roma, Urartu ve Hitit eserlerinin modern bir sunumla sergilendiği özel müze.' },
  { ad: 'Kahramankazan 15 Temmuz Şehitleri ve Demokrasi Müzesi', il: 'Ankara', ilce: 'Kahramankazan', latitude: 40.1472, longitude: 32.6842, bilgi: '15 Temmuz darbe girişimi sırasında yaşananları ve demokrasi mücadelesini anlatan, dijital ve interaktif sergileri olan bir müze.' },
  { ad: 'Güvenlik Anıtı', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9208, longitude: 32.8553, bilgi: 'Kızılay Meydanı Güvenpark içinde yer alan, "Türk, Öğün, Çalış, Güven" ilkesini simgeleyen ve Atatürk\'ü de içeren anıtsal heykel grubu.' },
  { ad: 'Hamiye Çolakoğlu Seramik Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9328, longitude: 32.8469, bilgi: 'Hacettepe Üniversitesi bünyesinde, seramik sanatçısı Hamiye Çolakoğlu\'nun eserlerinin sergilendiği bir sanat müzesi.' },
  { ad: 'Azimi (İsmail Paşazade Hacı Esad) Türbesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9142, longitude: 32.8581, bilgi: 'Kızılay\'da, modern binaların arasında kalmış, 19. yüzyıldan kalma, altıgen planlı ve estetik bir türbe.' },
  { ad: 'Müze Evliyagil', il: 'Ankara', ilce: 'Gölbaşı', latitude: 39.8419, longitude: 32.7917, bilgi: 'Türkiye\'nin modern ve çağdaş sanat eserlerinden oluşan önemli bir özel koleksiyona ev sahipliği yapan bir sanat müzesi.' },
  { ad: 'Ankara Üniversitesi Tarihi Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9328, longitude: 32.8333, bilgi: 'Ankara Üniversitesi\'nin tarihi rektörlük binasında, üniversitenin kuruluşunu ve tarihini anlatan müze.' },
  { ad: 'Hacettepe Sanat Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9325, longitude: 32.8475, bilgi: '19. yüzyıldan günümüze Türk resim sanatının önemli örneklerini barındıran, Hacettepe Üniversitesi\'ne bağlı bir müze.' },
  { ad: 'Türkpusat Geleneksel Savaş Pusatları Müzesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9417, longitude: 32.8653, bilgi: 'Ankara Kalesi içinde, binlerce yıllık Türk tarihine ait ok, yay, kılıç gibi savaş aletlerinin sergilendiği özel bir müze.' },
  { ad: 'Hocalı Anıtı', il: 'Ankara', ilce: 'Keçiören', latitude: 39.9867, longitude: 32.8661, bilgi: 'Hocalı Katliamı\'nda hayatını kaybeden Azerbaycan Türklerinin anısına yapılmış olan anıt ve park.' },
  { ad: 'Ankara Üniversitesi Eczacılık Fakültesi Müzesi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9328, longitude: 32.8339, bilgi: 'Türkiye\'nin eczacılık tarihine ışık tutan, eski ilaçlar, havanlar ve laboratuvar aletlerinin sergilendiği müze.' },
  { ad: 'İş Sağlığı ve Güvenliği Müzesi', il: 'Ankara', ilce: 'Yenimahalle', latitude: 39.9483, longitude: 32.8258, bilgi: 'Türkiye\'de iş sağlığı ve güvenliği kültürünün gelişimini, kullanılan koruyucu ekipmanları ve yaşananları sergileyen müze.' },
  { ad: 'Ankara Devlet Güzel Sanatlar Galerisi', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9242, longitude: 32.8583, bilgi: 'Milli Kütüphane kompleksinde yer alan, süreli resim ve heykel sergilerinin düzenlendiği önemli bir sanat galerisi.' },
  { ad: 'Atatürk Vagonu Müzesi', il: 'Ankara', ilce: 'Yenimahalle', latitude: 39.9481, longitude: 32.7933, bilgi: 'Atatürk Orman Çiftliği içinde, Atatürk\'ün yurt içi gezilerinde kullandığı orijinal beyaz trenin vagonunun sergilendiği yer.' },
  { ad: 'Augustus Tapınağı', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9442, longitude: 32.8592, bilgi: 'Hacı Bayram Veli Camii\'nin bitişiğinde, Roma İmparatoru Augustus\'un icraatlarını anlatan "Res Gestae" yazıtıyla ünlü anıtsal yapı.' },
  { ad: 'Karacabey Hamamı', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9347, longitude: 32.8681, bilgi: '15. yüzyıldan kalma, Ankara\'nın en büyük ve en iyi korunmuş tarihi Türk hamamlarından biri.' },
  { ad: 'Ahmet Hamdi Akseki Camii', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9097, longitude: 32.8092, bilgi: 'Modern mimarinin en dikkat çekici örneklerinden, Diyanet İşleri Başkanlığı kompleksinde yer alan görkemli cami.' },
  { ad: 'Bilkent Doğramacızade Ali Paşa Camii', il: 'Ankara', ilce: 'Çankaya', latitude: 39.8711, longitude: 32.7481, bilgi: 'Mimar Sinan\'ın Selimiye Camii\'nden esinlenerek tasarlanmış, modern dönem cami mimarisinin zirve noktalarından biri.' },
  { ad: 'Ankara Palas', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9411, longitude: 32.8544, bilgi: 'Cumhuriyetin ilk yıllarında devletin resmi konukevi olarak kullanılan, mimari ve tarihi öneme sahip bir yapı.' },
  { ad: 'Atakule', il: 'Ankara', ilce: 'Çankaya', latitude: 39.8906, longitude: 32.8536, bilgi: 'Modern Ankara\'nın simgesi haline gelmiş, döner restoranı ve seyir terası bulunan ikonik kule.' },
  { ad: 'Hitit Güneş Kursu Anıtı', il: 'Ankara', ilce: 'Çankaya', latitude: 39.9304, longitude: 32.8564, bilgi: 'Sıhhiye Meydanı\'nda yer alan, Hitit medeniyetinin ve Ankara\'nın sembolü haline gelmiş anıt.' },
  { ad: 'Ankara Garı (TCDD Gar Binası)', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9367, longitude: 32.8436, bilgi: 'Art Deco tarzının Türkiye\'deki en güzel örneklerinden, Cumhuriyetin modernleşme vizyonunu yansıtan mimari anıt.' },
  { ad: 'Pembe Köşk (İsmet İnönü Evi)', il: 'Ankara', ilce: 'Çankaya', latitude: 39.8911, longitude: 32.8631, bilgi: 'Türkiye\'nin ikinci Cumhurbaşkanı İsmet İnönü\'nün evi olan ve siyasi tarihimizde birçok önemli kararın alındığı müze ev.' },
  { ad: 'CSO Ada Ankara', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9381, longitude: 32.8450, bilgi: 'Dünya standartlarında akustiği ve modern mimarisiyle Ankara\'nın yeni kültür ve sanat simgesi olan konser salonu kompleksi.' },
  { ad: 'Opera Sahnesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9358, longitude: 32.8539, bilgi: 'Ulus\'ta bulunan, 1948\'den beri hizmet veren, Cumhuriyet dönemi kültür hayatının ve sahne sanatlarının en köklü merkezi.' },
  { ad: 'Şengül Hamamı', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9439, longitude: 32.8581, bilgi: 'Ulus\'ta bulunan, 15. yüzyıla tarihlenen bir diğer önemli tarihi Osmanlı hamamıdır.' },
  { ad: 'Leblebici Camii', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9389, longitude: 32.8611, bilgi: 'Samanpazarı\'nda bulunan, 15. yüzyıldan kalma, küçük ama tarihi dokusuyla dikkat çeken bir Osmanlı camisi.' },
  { ad: 'Gülbaba Türbesi', il: 'Ankara', ilce: 'Altındağ', latitude: 39.9450, longitude: 32.8589, bilgi: 'Hacı Bayram Veli Camii yakınında bulunan, halk arasında sevilen ve manevi bir atmosferi olan küçük ve tarihi bir türbe.' },
  { ad: 'Beştepe Millet Külliyesi', il: 'Ankara', ilce: 'Yenimahalle', latitude: 39.9317, longitude: 32.7911, bilgi: 'Türkiye Cumhuriyeti Cumhurbaşkanlığı\'nın resmi çalışma ofislerini ve konutunu barındıran modern ve anıtsal yapı kompleksi.' },
  { ad: 'Millet Kütüphanesi', il: 'Ankara', ilce: 'Yenimahalle', latitude: 39.9308, longitude: 32.7931, bilgi: 'Cumhurbaşkanlığı Külliyesi içinde yer alan, Türkiye\'nin en büyük kütüphanesi olup, milyonlarca basılı ve dijital kaynağa ev sahipliği yapar.' },
  { ad: 'Beştepe Millet Camii', il: 'Ankara', ilce: 'Yenimahalle', latitude: 39.9300, longitude: 32.7900, bilgi: 'Cumhurbaşkanlığı Külliyesi kompleksinin bir parçası olan, modern ve klasik unsurları birleştiren büyük kapasiteli cami.' }

];
// --- Popüler Rotalar Verisi ---
export const popülerRotalar = [
  {
    id: 'ist001',
    baslik: 'Tarihi Yarımada Klasikleri',
    aciklama: 'İstanbul\'un en ikonik yapılarını keşfedin. Bizans ve Osmanlı İmparatorluklarının kalbine yolculuk.',
    ortalamaSure: 'Tam Gün (6-8 saat)',
    icerdiğiYapılar: [
      'Ayasofya Camii',
      'Sultanahmet Camii (Mavi Cami)',
      'Topkapı Sarayı',
      'Yerebatan Sarnıcı',
      'Türk ve İslam Eserleri Müzesi',
      'Hipodrom',
    ],
    mekanDetaylari: [
      { ad: 'Ayasofya Camii', bilgi: 'Bizans ve Osmanlı mimarisinin görkemli birleşimi, yüzyıllar boyunca dünyanın en büyük ibadethanelerinden biri olmuştur. Bugün hala dini ve kültürel bir merkezdir.' },
      { ad: 'Sultanahmet Camii (Mavi Cami)', bilgi: 'İç mekanındaki göz alıcı mavi çinileriyle ünlü, 17. yüzyıldan kalma büyüleyici bir Osmanlı şaheseridir. Sultanahmet Meydanı\'nın simgesidir.' },
      { ad: 'Topkapı Sarayı', bilgi: 'Osmanlı İmparatorluğu\'nun neredeyse 400 yıl boyunca ana ikametgahı ve yönetim merkezi. Harem, Kutsal Emanetler ve etkileyici mücevher koleksiyonlarına ev sahipliği yapar.' },
      { ad: 'Yerebatan Sarnıcı', bilgi: 'Bizans döneminden kalma devasa bir yeraltı sarnıcı. En çok ilgi çeken detayları ise ters duran Medusa başlarıdır.' },
      { ad: 'Türk ve İslam Eserleri Müzesi', bilgi: 'Türk ve İslam sanatının eşsiz örneklerini barındıran, İbrahim Paşa Sarayı\'nda yer alan önemli bir müzedir. Halı koleksiyonu özellikle dikkat çekicidir.' },
      { ad: 'Hipodrom', bilgi: 'Antik Bizans döneminde at yarışları ve sosyal etkinlikler için kullanılan, günümüzde dikilitaşlar ve yılanlı sütun gibi kalıntıları barındıran tarihi bir meydandır.' },
    ],
    nelerOgreneceksiniz: [
      'Bizans ve Osmanlı imparatorluklarının mimari ve sanatsal izlerini yakından tanıyacaksınız.',
      'İstanbul\'un fetih sonrası nasıl bir kültürel dönüşüm geçirdiğini gözlemleyeceksiniz.',
      'Antik sarnıçların işlevleri ve etrafındaki gizemli hikayeler hakkında bilgi edineceksiniz.',
      'İki büyük medeniyetin birleştiği noktada mimari harikaları deneyimleyeceksiniz.',
    ],
    il: 'İstanbul',
    ilce: 'Fatih',
    gorsel: 'https://cdn.pixabay.com/photo/2016/09/27/12/32/hagia-sophia-1704283_1280.jpg',
  },
  {
    id: 'ist002',
    baslik: 'Bizans Kalıntıları ve Gizemleri',
    aciklama: 'Kapalıçarşı\'nın labirentlerinden Balat\'ın renkli sokaklarına, İstanbul\'un saklı Bizans hazinelerini keşfedin.',
    ortalamaSure: 'Yarım Gün (3-4 saat)',
    icerdiğiYapılar: [
      'Kapalıçarşı',
      'Mısır Çarşısı',
      'Süleymaniye Camii',
      'Fener Rum Ortodoks Patrikhanesi',
      'Balat Renkli Evleri',
      'Chora Kilisesi (Kariye Camii)',
    ],
    mekanDetaylari: [
      { ad: 'Kapalıçarşı', bilgi: 'Dünyanın en eski ve en büyük kapalı çarşılarından biri olan Kapalıçarşı, labirentvari sokakları ve binlerce dükkanıyla alışverişin ve tarihin kalbidir.' },
      { ad: 'Mısır Çarşısı', bilgi: 'Baharatların, lokumların ve geleneksel ürünlerin adresi olan Mısır Çarşısı, renkli ve egzotik atmosferiyle duyulara hitap eder.' },
      { ad: 'Süleymaniye Camii', bilgi: 'Mimar Sinan\'ın kalfalık eseri olarak kabul edilen Süleymaniye Camii, Osmanlı mimarisinin en görkemli örneklerinden biridir ve muhteşem bir Haliç manzarasına sahiptir.' },
      { ad: 'Fener Rum Ortodoks Patrikhanesi', bilgi: 'Dünya Ortodoks Kilisesi\'nin ruhani merkezi olan Patrikhane, Fener\'in tarihi atmosferinde önemli bir dini ve kültürel yapıdır.' },
      { ad: 'Balat Renkli Evleri', bilgi: 'Restore edilmiş rengarenk tarihi evleri, dar sokakları ve butik kafeleriyle fotoğrafçıların ve gezginlerin gözdesi olan Balat\'ın eşsiz mahalle atmosferi.' },
      { ad: 'Chora Kilisesi (Kariye Camii)', bilgi: 'Muhteşem Bizans mozaikleri ve freskleriyle bilinen, Hristiyan ve İslam sanatının birleştiği ender yapılarından biridir.' },
    ],
    nelerOgreneceksiniz: [
      'İstanbul\'un Bizans ve Osmanlı dönemlerindeki ticari yaşamının canlılığını hissedeceksiniz.',
      'Eski çarşı kültürünün işleyişi ve günlük yaşamdaki yerini öğreneceksiniz.',
      'Fatih ve Balat\'ın çok kültürlü, derin tarihini ve mimari farklılıklarını keşfedeceksiniz.',
      'Gizli Bizans kalıntılarını ve Haliç\'in eşsiz atmosferini deneyimleyeceksiniz.',
    ],
    il: 'İstanbul',
    ilce: 'Fatih',
    gorsel: 'https://cdn.pixabay.com/photo/2019/08/25/16/04/grand-bazaar-4428987_1280.jpg',
  },
  {
    id: 'ist003',
    baslik: 'Haliç Boyunca Tarih ve Manzara',
    aciklama: 'Haliç\'in eşsiz manzarası eşliğinde Eyüpsultan\'dan Miniatürk\'e uzanan tarihi bir yolculuk.',
    ortalamaSure: 'Yarım Gün (3-5 saat)',
    icerdiğiYapılar: [
      'Eyüp Sultan Camii',
      'Pierre Loti Tepesi',
      'Miniatürk',
      'Rahmi M. Koç Müzesi',
      'Feshane',
    ],
    mekanDetaylari: [
      { ad: 'Eyüp Sultan Camii', bilgi: 'İstanbul\'un en kutsal mekanlarından biri, Eyüp Sultan Hazretleri\'nin türbesine ev sahipliği yapar. Manevi atmosferiyle ziyaretçileri kendine çeker.' },
      { ad: 'Pierre Loti Tepesi', bilgi: 'Haliç\'in panoramik manzarasını sunan ünlü bir tepe. Adını Fransız yazar Pierre Loti\'den almıştır ve eşsiz gün batımlarıyla bilinir.' },
      { ad: 'Miniatürk', bilgi: 'Türkiye\'den ve Osmanlı coğrafyasından seçilmiş önemli yapıların minyatür modellerinin sergilendiği açık hava müzesidir. Tarihi bir yolculuk sunar.' },
      { ad: 'Rahmi M. Koç Müzesi', bilgi: 'Sanayi ve ulaşım tarihine adanmış Türkiye\'nin ilk ve tek sanayi müzesi. Klasik otomobillerden denizaltılara kadar geniş bir koleksiyona sahiptir.' },
      { ad: 'Feshane', bilgi: 'Tarihi bir fabrika binası olan Feshane, günümüzde çeşitli kültürel ve sanatsal etkinliklere ev sahipliği yapan bir sergi ve kongre merkezidir.' },
    ],
    nelerOgreneceksiniz: [
      'Haliç\'in İstanbul tarihindeki önemini ve coğrafi güzelliğini kavrayacaksınız.',
      'Osmanlı döneminin önemli şahsiyetlerinden Eyüp Sultan Hazretleri\'nin manevi mirasını tanıyacaksınız.',
      'Türkiye\'nin ve Osmanlı İmparatorluğu\'nun çeşitli bölgelerinden mimari harikaları minyatür olarak gözlemleyeceksiniz.',
      'Sanayi ve ulaşım tarihinin gelişimini interaktif bir şekilde deneyimleyeceksiniz.',
    ],
    il: 'İstanbul',
    ilce: 'Eyüpsultan',
    gorsel: 'https://cdn.pixabay.com/photo/2020/01/21/10/37/istanbul-4783307_1280.jpg',
  },
  {
    id: 'ist004',
    baslik: 'Beyoğlu: Modern Sanat ve Tarih',
    aciklama: 'İstiklal Caddesi\'nden Galata\'ya, İstanbul\'un modern yüzünü ve sanat galerilerini keşfedin.',
    ortalamaSure: 'Tam Gün (5-7 saat)',
    icerdiğiYapılar: [
      'İstiklal Caddesi',
      'Taksim Meydanı',
      'Galata Kulesi',
      'Pera Müzesi',
      'Çiçek Pasajı',
      'Salt Galata',
    ],
    mekanDetaylari: [
      { ad: 'İstiklal Caddesi', bilgi: 'İstanbul\'un en canlı caddelerinden biri, mağazaları, kafeleri, sinemaları ve tarihi binalarıyla doludur. Nostaljik tramvay hattı buradan geçer.' },
      { ad: 'Taksim Meydanı', bilgi: 'İstanbul\'un kalbi sayılan ve önemli toplumsal olaylara sahne olan merkezi bir meydandır. Cumhuriyet Anıtı burada yer alır.' },
      { ad: 'Galata Kulesi', bilgi: 'Cenevizliler tarafından inşa edilmiş, İstanbul\'un en sembolik yapılarından biridir. Şehrin panoramik manzarasını sunar.' },
      { ad: 'Pera Müzesi', bilgi: 'Oryantalist Resim Koleksiyonu, Anadolu Ağırlık ve Ölçüleri Koleksiyonu ve Kütahya Çini ve Seramikleri Koleksiyonu ile öne çıkan bir sanat müzesidir.' },
      { ad: 'Çiçek Pasajı', bilgi: 'Tarihi bir pasaj olan Çiçek Pasajı, restoranları ve eğlence mekanlarıyla ünlüdür. Beyoğlu\'nun canlı atmosferinin bir parçasıdır.' },
      { ad: 'Salt Galata', bilgi: 'Tarihi Osmanlı Bankası binasında yer alan Salt Galata, modern ve çağdaş sanata, araştırmaya ve kamusal programlara ev sahipliği yapan bir kültür kurumudur.' },
    ],
    nelerOgreneceksiniz: [
      'İstanbul\'un modernleşme sürecini ve Batı\'ya açılan yüzünü keşfedeceksiniz.',
      'Tarihi Beyoğlu semtinin çok katmanlı kültürel dokusunu deneyimleyeceksiniz.',
      'Çağdaş sanatın Türkiye\'deki gelişimini ve önemli eserlerini gözlemleyeceksiniz.',
      'İstanbul\'un canlı sokak yaşamının ve sosyal tarihinin izlerini süreceksiniz.',
    ],
    il: 'İstanbul',
    ilce: 'Beyoğlu',
    gorsel: 'https://cdn.pixabay.com/photo/2017/09/16/17/28/galata-tower-2756281_1280.jpg',
  },
  {
    id: 'ist005',
    baslik: 'Boğazın İncileri: Saraylar ve Parklar',
    aciklama: 'Boğaz hattı boyunca uzanan görkemli Osmanlı saraylarını ve tarihi parkları ziyaret edin.',
    ortalamaSure: 'Tam Gün (6-8 saat)',
    icerdiğiYapılar: [
      'Dolmabahçe Sarayı',
      'Çırağan Sarayı',
      'Yıldız Sarayı',
      'Ortaköy Camii',
      'Yıldız Parkı',
      'Beşiktaş Çarşısı',
    ],
    mekanDetaylari: [
      { ad: 'Dolmabahçe Sarayı', bilgi: 'Osmanlı İmparatorluğu\'nun son dönemlerine ait, Boğaz kıyısında yer alan görkemli bir saray. Avrupa mimarisi ve Osmanlı süsleme sanatının birleşimiyle inşa edilmiştir.' },
      { ad: 'Çırağan Sarayı', bilgi: 'Boğaz\'ın kıyısında yer alan bu tarihi saray, günümüzde lüks bir otel olarak hizmet vermektedir. Osmanlı zarafetinin bir simgesidir.' },
      { ad: 'Yıldız Sarayı', bilgi: 'Osmanlı İmparatorluğu\'nun son döneminde saray kompleksleri arasında önemli bir yere sahip olan Yıldız Sarayı, köşkleri ve bahçeleriyle bilinir.' },
      { ad: 'Ortaköy Camii', bilgi: 'Boğaz Köprüsü\'nün hemen altında, suyun kenarında yer alan ve fotoğrafçıların favorisi olan zarif bir Neo-Barok camidir.' },
      { ad: 'Yıldız Parkı', bilgi: 'Şehir merkezine yakın, doğal güzellikleri ve tarihi köşkleriyle bilinen büyük bir parktır. İstanbul\'un yeşil kaçış noktalarından biridir.' },
      { ad: 'Beşiktaş Çarşısı', bilgi: 'Canlı ve hareketli bir çarşı. Balık pazarından giyim mağazalarına, restoran ve kafelere kadar birçok seçenek sunar.' },
    ],
    nelerOgreneceksiniz: [
      'Osmanlı İmparatorluğu\'nun modernleşme dönemindeki mimari ve sanatsal değişimlerini gözlemleyeceksiniz.',
      'Boğaz\'ın stratejik ve estetik önemini ve burada kurulan sarayların hikayelerini öğreneceksiniz.',
      'İstanbul\'un kentsel dönüşümünü ve sarayların şehir hayatına etkilerini anlayacaksınız.',
      'Boğaz\'ın eşsiz manzarasının tadını çıkararak tarihi ve doğal güzellikleri bir arada deneyimleyeceksiniz.',
    ],
    il: 'İstanbul',
    ilce: 'Beşiktaş',
    gorsel: 'https://cdn.pixabay.com/photo/2019/04/18/16/24/dolmabahce-palace-4137276_1280.jpg',
  },
  {
    id: 'ist006',
    baslik: 'Anadolu Yakası: Kadıköy ve Üsküdar',
    aciklama: 'Boğaz\'ın Anadolu yakasındaki canlı semtleri Kadıköy ve Üsküdar\'ı keşfederek farklı bir İstanbul deneyimi yaşayın.',
    ortalamaSure: 'Tam Gün (5-7 saat)',
    icerdiğiYapılar: [
      'Kız Kulesi',
      'Üsküdar Sahili',
      'Haydarpaşa Garı',
      'Kadıköy Çarşısı',
      'Moda Sahili',
      'Bağdat Caddesi',
    ],
    mekanDetaylari: [
      { ad: 'Kız Kulesi', bilgi: 'Boğaz\'ın ortasında yer alan ve hakkında birçok efsane anlatılan ikonik bir kule. İstanbul\'un en romantik simgelerinden biridir.' },
      { ad: 'Üsküdar Sahili', bilgi: 'Kız Kulesi manzarası eşliğinde çay içebileceğiniz, balık tutabileceğiniz veya sadece Boğaz havası alabileceğiniz sakin bir sahil şeridi.' },
      { ad: 'Haydarpaşa Garı', bilgi: 'Mimari güzelliği ve tarihi önemiyle öne çıkan, Anadolu\'ya açılan bir kapı niteliğindeki eski tren garı.' },
      { ad: 'Kadıköy Çarşısı', bilgi: 'Baharatçılardan balıkçılara, antikacılardan kafe ve restoranlara kadar birçok farklı dükkanı barındıran hareketli bir çarşı.' },
      { ad: 'Moda Sahili', bilgi: 'Kadıköy\'ün en popüler semtlerinden Moda\'nın sahil şeridi. Yürüyüş, koşu veya sadece deniz kenarında dinlenmek için idealdir.' },
      { ad: 'Bağdat Caddesi', bilgi: 'İstanbul\'un en uzun ve prestijli alışveriş caddelerinden biri. Lüks mağazaları, kafeleri ve restoranlarıyla ünlüdür.' },
    ],
    nelerOgreneceksiniz: [
      'İstanbul\'un iki yakası arasındaki kültürel ve yaşam tarzı farklılıklarını deneyimleyeceksiniz.',
      'Kadıköy ve Üsküdar\'ın kendine özgü semt atmosferlerini ve tarihi dokularını keşfedeceksiniz.',
      'Anadolu yakasının sosyal yaşamının ve ticari hareketliliğinin izlerini süreceksiniz.',
      'Kız Kulesi gibi İstanbul\'un sembollerinin arkasındaki efsaneleri ve gerçekleri öğreneceksiniz.',
    ],
    il: 'İstanbul',
    ilce: 'Kadıköy',
    gorsel: 'https://cdn.pixabay.com/photo/2016/11/08/04/43/maiden-s-tower-1807094_1280.jpg',
  },
  {
    id: 'ist007',
    baslik: 'Prens Adaları: Büyükada Huzuru',
    aciklama: 'İstanbul\'un karmaşasından uzaklaşıp Marmara Denizi\'nin ortasında huzurlu bir gün geçirin, Büyükada\'nın tarihi köşklerini ve doğal güzelliklerini keşfedin.',
    ortalamaSure: 'Tam Gün (Feribot dahil 6-8 saat)',
    icerdiğiYapılar: [
      'Adalar Müzesi',
      'Rum Yetimhanesi (Büyükada Rum Yetimhanesi)',
      'Aya Yorgi Kilisesi',
      'Reşat Nuri Güntekin Evi',
      'Fayton Meydanı (elektrikli araçlar için)',
    ],
    mekanDetaylari: [
      { ad: 'Adalar Müzesi', bilgi: 'Prens Adaları\'nın tarihi, kültürü ve doğal yaşamı hakkında bilgi veren, eski bir helikopter hangarında yer alan modern bir müzedir.' },
      { ad: 'Rum Yetimhanesi (Büyükada Rum Yetimhanesi)', bilgi: 'Dünyanın en büyük ahşap yapılarından biri olan bu devasa yetimhane binası, görkemli ama hüzünlü bir hikayeye sahiptir.' },
      { ad: 'Aya Yorgi Kilisesi', bilgi: 'Büyükada\'nın en yüksek tepesinde yer alan tarihi bir Rum Ortodoks kilisesi. Muhteşem manzarası ve manevi atmosferiyle ziyaretçileri cezbeder.' },
      { ad: 'Reşat Nuri Güntekin Evi', bilgi: 'Ünlü Türk yazar Reşat Nuri Güntekin\'in bir dönem yaşadığı ve günümüzde müze olarak ziyaret edilebilen tarihi köşk.' },
      { ad: 'Fayton Meydanı', bilgi: 'Büyükada\'da eskiden faytonların kalktığı, günümüzde ise adayı elektrikli araçlarla gezmek için başlangıç noktası olan merkezi bir meydan.' },
    ],
    nelerOgreneceksiniz: [
      'İstanbul\'un ada yaşamının sakinliğini ve doğal güzelliklerini deneyimleyeceksiniz.',
      'Adaların çok kültürlü geçmişini ve farklı etnik grupların izlerini keşfedeceksiniz.',
      'Büyükada\'nın tarihi köşk mimarisini ve ünlü sakinlerinin hikayelerini öğreneceksiniz.',
      'Şehrin gürültüsünden uzaklaşarak ruhunuzu dinlendirecek huzurlu bir gün geçireceksiniz.',
    ],
    il: 'İstanbul',
    ilce: 'Büyükada',
    gorsel: 'https://cdn.pixabay.com/photo/2020/12/07/04/38/princes-islands-5810232_1280.jpg',
  },
  {
    id: 'ist008',
    baslik: 'Fatih\'in Kalbi: Ecdad Yadigarı',
    aciklama: 'Fatih semtinin kalbinde yer alan, Osmanlı İmparatorluğu\'nun kurucularına adanmış camiler ve tarihi yapıları keşfedin.',
    ortalamaSure: 'Yarım Gün (3-4 saat)',
    icerdiğiYapılar: [
      'Fatih Camii',
      'Şehzade Camii',
      'Vefa Bozacısı',
      'Valens Su Kemeri',
      'Zeyrek Camii',
    ],
    mekanDetaylari: [
      { ad: 'Fatih Camii', bilgi: 'Fatih Sultan Mehmet tarafından yaptırılan ve İstanbul\'un en önemli dini yapılarından biri olan cami. Osmanlı mimarisinin görkemli örneklerindendir.' },
      { ad: 'Şehzade Camii', bilgi: 'Mimar Sinan\'ın "çıraklık eseri" olarak bilinen, Kanuni Sultan Süleyman\'ın oğlu Şehzade Mehmed anısına yapılmış zarif bir camidir.' },
      { ad: 'Vefa Bozacısı', bilgi: '1876 yılından beri geleneksel boza üretimi yapan, İstanbul\'un en köklü ve ünlü mekanlarından biridir.' },
      { ad: 'Valens Su Kemeri', bilgi: 'Roma İmparatoru Valens tarafından 4. yüzyılda inşa edilen ve İstanbul\'un su ihtiyacını karşılamak için kullanılan devasa bir su kemeri.' },
      { ad: 'Zeyrek Camii', bilgi: 'Aslen Bizans dönemine ait Pantokrator Manastırı Kilisesi olan yapı, Osmanlı döneminde camiye çevrilmiştir. Bizans mozaik ve fresk kalıntıları görülebilir.' },
    ],
    nelerOgreneceksiniz: [
      'Fatih Sultan Mehmet döneminden günümüze ulaşan mimari şaheserleri ve Osmanlı\'nın ilk başkentinin izlerini süreceksiniz.',
      'Mimar Sinan\'ın erken dönem eserlerini ve mimari üslubunun gelişimini gözlemleyeceksiniz.',
      'İstanbul\'un Bizans ve Osmanlı su kemerleri sistemi hakkında bilgi edineceksiniz.',
      'Geleneksel Türk içeceği bozanın tarihini ve tadını deneyimleyeceksiniz.',
    ],
    il: 'İstanbul',
    ilce: 'Fatih',
    gorsel: 'https://cdn.pixabay.com/photo/2016/09/27/12/32/fatih-mosque-1704283_1280.jpg', // Örnek görsel URL'si (Fatih Camii)
  },
  {
    id: 'ist009',
    baslik: 'Nişantaşı: Şıklık ve Sanat',
    aciklama: 'İstanbul\'un gözde semtlerinden Nişantaşı\'nda lüks mağazaları, sanat galerilerini ve tarihi yapıları keşfedin.',
    ortalamaSure: 'Yarım Gün (3-5 saat)',
    icerdiğiYapılar: [
      'Teşvikiye Camii',
      'Nişantaşı Abidesi',
      'City\'s Nişantaşı',
      'Maçka Demokrasi Parkı',
      'Milli Reasürans Sanat Galerisi',
    ],
    mekanDetaylari: [
      { ad: 'Teşvikiye Camii', bilgi: '19. yüzyılda inşa edilmiş, Neo-Barok üsluptaki zarif ve ikonik bir cami. Nişantaşı\'nın merkezinde yer alır.' },
      { ad: 'Nişantaşı Abidesi', bilgi: 'Sultan Abdülmecid tarafından yaptırılan ve semtin ismine de kaynaklık eden önemli bir abide.' },
      { ad: 'City\'s Nişantaşı', bilgi: 'Bölgenin en popüler alışveriş merkezlerinden biri. Uluslararası ve yerel markalara ev sahipliği yapar.' },
      { ad: 'Maçka Demokrasi Parkı', bilgi: 'Şehir merkezinde nefes alınacak, yürüyüş ve dinlenme imkanı sunan büyük bir parktır.' },
      { ad: 'Milli Reasürans Sanat Galerisi', bilgi: 'Türkiye\'nin önemli çağdaş sanat galerilerinden biri. Düzenli olarak sergilere ev sahipliği yapar.' },
    ],
    nelerOgreneceksiniz: [
      'İstanbul\'un modern ve şık yüzünü, kentsel dönüşümünü ve yaşam tarzını gözlemleyeceksiniz.',
      'Geç Osmanlı döneminden günümüze Nişantaşı\'nın sosyal ve kültürel gelişimini keşfedeceksiniz.',
      'Türk çağdaş sanatının önemli duraklarını ve galerilerini tanıyacaksınız.',
      'Şehrin kalbinde yer alan yeşil alanların önemini ve keyfini deneyimleyeceksiniz.',
    ],
    il: 'İstanbul',
    ilce: 'Şişli',
    gorsel: 'https://cdn.pixabay.com/photo/2020/09/02/19/33/nisantasi-5539567_1280.jpg', // Örnek görsel URL'si
  },
  {
    id: 'ist010',
    baslik: 'Çamlıca: Panoramik Manzara',
    aciklama: 'İstanbul\'un en yüksek noktalarından Çamlıca Tepesi\'nde hem tarihi hem de modern yapıları ziyaret ederek eşsiz şehir manzaralarının tadını çıkarın.',
    ortalamaSure: 'Yarım Gün (3-4 saat)',
    icerdiğiYapılar: [
      'Büyük Çamlıca Camii',
      'Çamlıca Kulesi',
      'Çamlıca Korusu',
      'Küçüksu Kasrı',
    ],
    mekanDetaylari: [
      { ad: 'Büyük Çamlıca Camii', bilgi: 'Türkiye\'nin en büyük camisi olan Büyük Çamlıca Camii, modern mimarisi ve etkileyici kapasitesiyle dikkat çeker. Panoramik İstanbul manzarasına sahiptir.' },
      { ad: 'Çamlıca Kulesi', bilgi: 'İstanbul\'un en yüksek yapılarından biri olan Çamlıca Kulesi, iletişim antenlerinin yanı sıra seyir terasları ve restoranlarla şehrin 360 derecelik manzarasını sunar.' },
      { ad: 'Çamlıca Korusu', bilgi: 'Şehir içindeki yeşil alanlardan biri olan Çamlıca Korusu, piknik yapmak, yürüyüş yapmak ve doğayla iç içe olmak için idealdir.' },
      { ad: 'Küçüksu Kasrı', bilgi: 'Boğaz kıyısında yer alan, Osmanlı Sultanları\'nın kısa süreli dinlenme ve av köşkleri olarak kullandığı zarif bir kasırdır. Neo-Barok tarzda inşa edilmiştir.' },
    ],
    nelerOgreneceksiniz: [
      'İstanbul\'un hem modern hem de geleneksel mimari eserlerini bir arada deneyimleyeceksiniz.',
      'Şehrin eşsiz coğrafyasını ve Boğaz\'ın stratejik konumunu yüksekten gözlemleyeceksiniz.',
      'Osmanlı ve Cumhuriyet dönemlerinin kültürel ve mimari izlerini karşılaştıracaksınız.',
      'Şehrin kalabalığından uzaklaşıp huzurlu ve yeşil alanlarda dinlenme fırsatı bulacaksınız.',
    ],
    il: 'İstanbul',
    ilce: 'Üsküdar',
    gorsel: 'https://cdn.pixabay.com/photo/2021/07/26/15/22/camlica-mosque-6494793_1280.jpg', // Örnek görsel URL'si
  },
];